// ============================================================
// STORE COMPARTIDO - Estado global via localStorage
// Conecta los 4 módulos: Cliente, Chofer, Transportista, SuperAdmin
// ============================================================
import { useState, useEffect } from 'react';

// ===== CATÁLOGO DE INSIGNIAS (usado en SuperAdmin y AppCliente) =====
export const CATALOGO_INSIGNIAS = [
  { id: 'pionero',     emoji: '🥇', label: 'Pionero',           desc: 'Una de las primeras empresas en unirse a Choyero',       color: 'bg-yellow-50 text-yellow-800 border border-yellow-300' },
  { id: 'top_generador', emoji: '🏆', label: 'Top Generador',   desc: 'Mayor número de viajes completados en la plataforma',    color: 'bg-orange-50 text-orange-800 border border-orange-300' },
  { id: 'elite',       emoji: '⭐', label: 'Élite',             desc: 'Calificación promedio de 4.9 o superior',                color: 'bg-amber-50 text-amber-800 border border-amber-300' },
  { id: 'diamante',    emoji: '💎', label: 'Diamante',          desc: 'GMV acumulado mayor a $200,000 MXN',                    color: 'bg-purple-50 text-purple-800 border border-purple-300' },
  { id: 'mas_activo',  emoji: '🔥', label: 'Más Activo',        desc: 'Mayor número de viajes en curso actualmente',           color: 'bg-red-50 text-red-800 border border-red-300' },
  { id: 'top_flota',   emoji: '🚛', label: 'Top Flota',         desc: 'Mayor número de unidades registradas en la plataforma', color: 'bg-green-50 text-green-800 border border-green-300' },
  { id: 'leal',        emoji: '🎖️', label: 'Leal',              desc: 'Más de 6 meses activo en Choyero',                      color: 'bg-blue-50 text-blue-800 border border-blue-300' },
  { id: 'verificado',  emoji: '✅', label: 'Verificado',         desc: 'Empresa verificada y auditada por Choyero',             color: 'bg-teal-50 text-teal-800 border border-teal-300' },
  { id: 'socio',       emoji: '🤝', label: 'Socio Estratégico', desc: 'Socio estratégico con acuerdo especial con Choyero',    color: 'bg-indigo-50 text-indigo-800 border border-indigo-300' },
  { id: 'destacado',   emoji: '🌟', label: 'Destacado',         desc: 'Empresa destacada y recomendada por la plataforma',     color: 'bg-pink-50 text-pink-800 border border-pink-300' },
];

// ===== CATÁLOGO DE INSIGNIAS DE CLIENTE =====
export const CATALOGO_INSIGNIAS_CLIENTE = [
  { id: 'leal',         emoji: '🎖️', label: 'Leal',           desc: 'Cliente con más de 6 meses activo en Choyero',         color: 'bg-blue-50 text-blue-800 border border-blue-300' },
  { id: 'frecuente',    emoji: '🔁', label: 'Frecuente',       desc: '10 o más fletes completados en la plataforma',         color: 'bg-orange-50 text-orange-800 border border-orange-300' },
  { id: 'buen_pagador', emoji: '💳', label: 'Buen Pagador',    desc: 'Historial de pagos sin retrasos ni cancelaciones',      color: 'bg-green-50 text-green-800 border border-green-300' },
  { id: 'premium',      emoji: '💎', label: 'Premium',         desc: 'Gasto acumulado mayor a $100,000 MXN en la plataforma', color: 'bg-purple-50 text-purple-800 border border-purple-300' },
  { id: 'vip',          emoji: '⭐', label: 'VIP',             desc: 'Cliente VIP con atención prioritaria',                  color: 'bg-amber-50 text-amber-800 border border-amber-300' },
  { id: 'embajador',    emoji: '🤝', label: 'Embajador',       desc: 'Ha referido nuevos clientes a la plataforma',           color: 'bg-indigo-50 text-indigo-800 border border-indigo-300' },
  { id: 'puntual',      emoji: '⏱️', label: 'Puntual',         desc: 'Siempre disponible en tiempo para la recogida',         color: 'bg-teal-50 text-teal-800 border border-teal-300' },
];

// ===== DOCUMENTOS REQUERIDOS PARA OPERAR =====
// Documentos para persona moral (empresa / sociedad)
const DOCS_MORAL = [
  { id: 'acta_constitutiva',     nombre: 'Acta Constitutiva',          descripcion: 'Documento de constitución de la empresa' },
  { id: 'rfc',                   nombre: 'Constancia Fiscal RFC',       descripcion: 'Registro Federal de Contribuyentes' },
  { id: 'comprobante_domicilio', nombre: 'Comprobante de Domicilio',    descripcion: 'Máximo 3 meses de antigüedad' },
  { id: 'ine_representante',     nombre: 'INE del Representante Legal', descripcion: 'Identificación oficial vigente' },
  { id: 'poliza_seguro',         nombre: 'Póliza de Seguro',            descripcion: 'Seguro de carga vigente' },
  { id: 'permiso_sct',           nombre: 'Permiso SCT',                 descripcion: 'Permiso federal de autotransporte de carga' },
];

// Documentos para persona física (transportista individual)
const DOCS_FISICA = [
  { id: 'rfc',                   nombre: 'Constancia Fiscal RFC',  descripcion: 'Registro Federal de Contribuyentes' },
  { id: 'comprobante_domicilio', nombre: 'Comprobante de Domicilio', descripcion: 'Máximo 3 meses de antigüedad' },
  { id: 'ine_representante',     nombre: 'INE del Titular',        descripcion: 'Identificación oficial vigente' },
  { id: 'poliza_seguro',         nombre: 'Póliza de Seguro',       descripcion: 'Seguro de carga vigente' },
  { id: 'permiso_sct',           nombre: 'Permiso SCT',            descripcion: 'Permiso federal de autotransporte de carga' },
];

// Retorna la lista correcta según tipoPersona ('fisica' | 'moral' | undefined)
export const getDocumentosRequeridos = (tipoPersona) =>
  tipoPersona === 'fisica' ? DOCS_FISICA : DOCS_MORAL;

// Alias para compatibilidad con código que no conoce tipoPersona (muestra moral por defecto)
export const DOCUMENTOS_REQUERIDOS = DOCS_MORAL;

const STORE_KEY = 'choyero_store';

// Helpers para fechas dinámicas en datos semilla
const _iNow = new Date();
const _iIso  = (d) => d.toISOString();
const _iDate = (d) => d.toISOString().slice(0, 10);
const _iAgo  = (min)  => new Date(_iNow - min * 60000);
const _iAdd  = (days) => new Date(_iNow.getTime() + days * 86400000);

// ===== DATOS SEMILLA (se cargan la primera vez) =====
const initialState = {
  usuarios: [],
  solicitudes: [],
  cotizaciones: [],
  viajes: [],
  ordenesChofer: [],
  empresasPendientes: [],
  empresasActivas: [],
  historialEntregas: [],
  clientes: [],
  retornosVacios: [],
  plantillasRutas: [],
  canalesAdminCerrados: [],
  proOfertaOculta: [],
  comisionesRed: [],
  configPlataforma: {
    comisionPorcentaje: 20,
    comisionBasico: 20,
    comisionPro: 15,
    horasExclusivaPro: 6,
    zonasActivas: ['Baja California', 'Baja California Sur'],
    versionApp: '1.0.0',
    tiempoEsperaLocalMinutos: 30,
    difusionGlobal: false,
    pagoProHabilitado: false,
    precioProMensual: 599,
    mensajePagoProDeshabilitado: 'La suscripción PRO estará disponible próximamente en tu región.',
    redMercadeo: {
      habilitada: true,
      bonoTransN1: 300, bonoTransN2: 150, bonoTransN3: 50,
      bonoClienteN1: 150, bonoClienteN2: 75, bonoClienteN3: 25,
      pctFleteN1: 3, pctFleteN2: 1.5, pctFleteN3: 0.5,
      pctFleteClienteN1: 2, pctFleteClienteN2: 1, pctFleteClienteN3: 0.5,
      diasExpiracion: 60,
    },
  },
  flota: [],
  plantillaChoferes: [],
  calificaciones: [],
  ubicacionesChoferes: {},
  mensajes: [],
  notificaciones: null
};

// ============================================================
// API DEL STORE
// ============================================================

/** Lee el estado completo del localStorage */
export const getStore = () => {
  try {
    const data = localStorage.getItem(STORE_KEY);
    if (!data) {
      localStorage.setItem(STORE_KEY, JSON.stringify(initialState));
      return initialState;
    }
    const parsed = JSON.parse(data);
    const migrated = { ...initialState, ...parsed };
    return migrated;
  } catch (e) {
    console.warn('[Store] Estado corrupto, usando estado inicial:', e.message);
    return initialState;
  }
};

/** Escribe el estado completo y dispara evento de sincronización */
export const setStore = (newState) => {
  localStorage.setItem(STORE_KEY, JSON.stringify(newState));
  window.dispatchEvent(new CustomEvent('choyero_sync', { detail: newState }));
};

/** Actualiza el estado con una función transformadora */
export const updateStore = (updater) => {
  const current = getStore();
  const updated = updater(current);
  setStore(updated);
  return updated;
};

/** Resetea el store a los datos iniciales (útil para demos) */
export const resetStore = () => {
  setStore(initialState);
  return initialState;
};

// ============================================================
// HOOK: useStore - Sincronización reactiva con el store
// ============================================================

export const useStore = () => {
  const [store, setLocalStore] = useState(getStore);

  useEffect(() => {
    const handleSync = () => setLocalStore(getStore());
    window.addEventListener('choyero_sync', handleSync);
    window.addEventListener('storage', handleSync);
    return () => {
      window.removeEventListener('choyero_sync', handleSync);
      window.removeEventListener('storage', handleSync);
    };
  }, []);

  const dispatch = (updater) => {
    const updated = updateStore(updater);
    setLocalStore(updated);
  };

  return { store, dispatch };
};

// ============================================================
// HELPERS DE AUTENTICACIÓN
// ============================================================

export const login = (email, password) => {
  // La autenticación se hace vía API — nunca comparar passwords en cliente
  // Esta función de login local es solo para compatibilidad con modo demo/offline.
  // En producción, usar apiLogin() de api.js que autentica contra el backend.
  const store = getStore();
  const usuario = store.usuarios.find(u => u.email === email && u.password === password); // eslint-disable-line no-unused-vars -- demo only
  if (!usuario) return null;
  if (usuario.status === 'pendiente') return { pendiente: true, nombre: usuario.nombre };
  if (usuario.activo === false) return { bloqueado: true, nombre: usuario.nombre };

  // Bloquear acceso si la empresa está suspendida
  if (usuario.rol === 'transportista' || usuario.rol === 'chofer') {
    const empresa = store.empresasActivas.find(e => e.id === usuario.empresaId);
    if (empresa && empresa.status === 'suspendida') {
      const ultimaSancion = (empresa.historialSanciones || []).filter(s => s.tipo === 'suspension').slice(-1)[0];
      return { suspendido: true, nombre: usuario.nombre, empresa: empresa.nombre, motivo: ultimaSancion?.motivo || null };
    }
  }

  return usuario;
};

/** Registrar nueva empresa transportista (crea usuario pendiente + empresa pendiente) */
export const registrarTransportista = ({ empresa, credenciales }) => {
  const empresaId = `E-${Date.now()}`;
  const usuarioId = `U-T-${Date.now()}`;
  return updateStore(store => {
    if (store.usuarios.find(u => u.email === credenciales.email)) return store;
    const nuevaEmpresaPendiente = {
      id: empresaId,
      nombre: empresa.nombre,
      rfc: empresa.rfc,
      representante: empresa.representante,
      email: empresa.emailContacto || credenciales.email,
      telefono: empresa.telefono,
      ciudad: empresa.ciudad || null,
      direccion: empresa.direccion,
      flota: `${empresa.flota} unidades`,
      fechaSolicitud: new Date().toISOString().split('T')[0],
      documentos: [],
      documentosEmpresa: DOCUMENTOS_REQUERIDOS.map(d => ({
        id: d.id,
        nombre: d.nombre,
        status: 'pendiente',
        fileDataUrl: null,
        fileName: null,
      }))
    };
    const nuevoUsuario = {
      id: usuarioId,
      nombre: empresa.nombre,
      email: credenciales.email,
      password: credenciales.password,
      rol: 'transportista',
      avatar: empresa.nombre.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase(),
      empresaId,
      status: 'activo',
      telefono: empresa.telefono || ''
    };
    // Notificar a superadmin de nueva empresa pendiente
    const notificaciones = _agregarNotif(store, {
      destinatarioRol: 'superadmin',
      tipo: 'empresa_pendiente',
      titulo: '🏢 Nueva empresa solicita aprobación',
      mensaje: `${empresa.nombre} envió su documentación y espera revisión para operar en la plataforma.`,
      datos: { empresaId }
    });
    return {
      ...store,
      empresasPendientes: [...store.empresasPendientes, nuevaEmpresaPendiente],
      usuarios: [...store.usuarios, nuevoUsuario],
      notificaciones
    };
  });
};

/** TRANSPORTISTA: Guardar logo de empresa (base64) */
export const actualizarLogoEmpresa = (empresaId, logo) => {
  return updateStore(store => ({
    ...store,
    empresasActivas: store.empresasActivas.map(e =>
      e.id === empresaId ? { ...e, logo } : e
    )
  }));
};

/** USUARIO: Guardar foto de perfil (base64) */
export const actualizarFotoUsuario = (usuarioId, foto) => {
  return updateStore(store => ({
    ...store,
    usuarios: store.usuarios.map(u =>
      u.id === usuarioId ? { ...u, foto } : u
    )
  }));
};

/** Registrar nuevo cliente (acceso inmediato, sin aprobación) */
export const registrarCliente = ({ datos, credenciales }) => {
  const usuarioId = `U-C-${Date.now()}`;
  return updateStore(store => {
    if (store.usuarios.find(u => u.email === credenciales.email)) return store;
    const nuevoUsuario = {
      id: usuarioId,
      nombre: datos.tipoPersona === 'fisica' ? datos.nombre : datos.razonSocial,
      email: credenciales.email,
      password: credenciales.password,
      rol: 'cliente',
      avatar: (datos.tipoPersona === 'fisica' ? datos.nombre : datos.razonSocial)
        .split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase(),
      tipoPersona: datos.tipoPersona,
      curp: datos.curp || null,
      rfc: datos.rfc || null,
      representante: datos.representante || null,
      telefono: datos.telefono,
      ciudad: datos.ciudad || null,
      direccion: datos.calleNumero ? `${datos.calleNumero}, ${datos.ciudad}` : (datos.ciudad || null),
      status: 'activo'
    };
    return { ...store, usuarios: [...store.usuarios, nuevoUsuario] };
  });
};

/** TRANSPORTISTA: Cambiar estado activo/inactivo de un chofer */
export const toggleActivoChofer = (email, activo) => {
  return updateStore(store => ({
    ...store,
    usuarios: store.usuarios.map(u => u.email === email && u.rol === 'chofer' ? { ...u, activo } : u)
  }));
};

/** TRANSPORTISTA: Crear credenciales de acceso para un chofer */
export const crearAccesoChofer = ({ nombre, email, password, telefono, licencia, empresaId, empresaNombre }) => {
  return updateStore(store => {
    // Verificar que el email no exista ya
    if (store.usuarios.find(u => u.email === email)) return store;
    const id = `U-CH-${Date.now()}`;
    const nuevoUsuario = {
      id,
      nombre,
      email,
      password,
      rol: 'chofer',
      avatar: nombre.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase(),
      empresa: empresaNombre || '',
      empresaId,
      telefono: telefono || '',
      licencia: licencia || '',
      viajesCompletados: 0,
      calificacion: null,
      kmRecorridos: 0,
      antiguedad: 'Nuevo'
    };
    return { ...store, usuarios: [...store.usuarios, nuevoUsuario] };
  });
};

/** TRANSPORTISTA: Verificar si un chofer ya tiene acceso */
export const choferTieneAcceso = (email) => {
  const { usuarios } = getStore();
  return !!usuarios.find(u => u.email === email && u.rol === 'chofer');
};

// Nota: se usa sessionStorage (no localStorage) deliberadamente para la sesión activa,
// de modo que cerrar la pestaña cierre la sesión. El store principal usa localStorage
// para persistir entre sesiones. Los tokens JWT viven en localStorage vía api.js.
export const getSesion = () => {
  try {
    const data = sessionStorage.getItem('choyero_sesion');
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
};

export const setSesion = (usuario) => {
  sessionStorage.setItem('choyero_sesion', JSON.stringify(usuario));
};

export const cerrarSesion = () => {
  sessionStorage.removeItem('choyero_sesion');
};

// ============================================================
// ============================================================
// COORDENADAS PARA CÁLCULO DE RUTAS (retornos vacíos)
// ============================================================
const _COORDS_RUTA = {
  // BC — Zona Tijuana/Rosarito
  'Tijuana, BC':              [32.5149, -117.0382],
  'Rosarito, BC':             [32.3656, -117.0640],
  'Playas de Rosarito, BC':   [32.3632, -117.0600],
  'La Misión, BC':            [32.0900, -116.8700],
  'El Descanso, BC':          [32.1500, -116.8800],
  'Primo Tapia, BC':          [32.2800, -116.9400],
  'Popotla, BC':              [32.0200, -116.8400],
  'Puerto Nuevo, BC':         [32.0600, -116.8800],
  // BC — Ensenada y costa noroeste
  'Ensenada, BC':             [31.8667, -116.6000],
  'El Sauzal, BC':            [31.9167, -116.6833],
  'Maneadero, BC':            [31.7167, -116.6000],
  'Valle de Guadalupe, BC':   [32.0167, -116.5333],
  'Punta Banda, BC':          [31.7000, -116.7000],
  'Santo Tomás, BC':          [31.5500, -116.4000],
  'Eréndira, BC':             [31.3700, -116.2500],
  'San Vicente, BC':          [31.3333, -116.2667],
  'Colonet, BC':              [30.9667, -116.0833],
  'Camalu, BC':               [30.8500, -116.0500],
  'San Quintín, BC':          [30.5491, -115.9839],
  'Vicente Guerrero, BC':     [30.7333, -116.0333],
  'El Rosario, BC':           [30.0667, -115.7167],
  // BC — Tecate y sierra
  'Tecate, BC':               [32.5736, -116.6258],
  'El Hongo, BC':             [32.5000, -116.2667],
  'La Rumorosa, BC':          [32.5333, -116.0667],
  'Valle de las Palmas, BC':  [32.3167, -116.5167],
  'Ojos Negros, BC':          [31.8667, -116.2500],
  // BC — Mexicali y valle
  'Mexicali, BC':             [32.6245, -115.4523],
  'Algodones, BC':            [32.7167, -114.7167],
  'San Felipe, BC':           [31.0249, -114.8390],
  'Guadalupe Victoria, BC':   [32.3000, -115.2000],
  'Ejido Nuevo León, BC':     [32.1500, -115.3000],
  'Ejido Sonora, BC':         [32.2000, -115.1500],
  'Ciudad Morelos, BC':       [32.5833, -114.9167],
  // BC — costa del golfo
  'Bahía de los Ángeles, BC': [28.9500, -113.5667],
  'El Mármol, BC':            [29.8000, -114.0000],
  'Punta Prieta, BC':         [28.9333, -114.1667],
  // BCS — Norte
  'Guerrero Negro, BCS':      [27.9667, -114.0000],
  'Bahía Asunción, BCS':      [27.1333, -114.2833],
  'Punta Abreojos, BCS':      [26.7167, -113.5500],
  'San Ignacio, BCS':         [27.2958, -112.8942],
  'Vizcaíno, BCS':            [27.8500, -113.8000],
  'Villa Alberto Andrés Alvarado, BCS': [27.6417, -113.3800],
  // BCS — Santa Rosalía / Mulegé
  'Santa Rosalía, BCS':       [27.3333, -112.2667],
  'Mulegé, BCS':              [26.8833, -111.9833],
  'San Carlos, BCS':          [24.7867, -112.1083],
  'Bahía Concepción, BCS':    [26.6833, -111.8667],
  'Loreto, BCS':              [26.0122, -111.3464],
  'Puerto Escondido, BCS':    [25.8333, -111.3333],
  // BCS — La Paz y alrededores
  'La Paz, BCS':              [24.1426, -110.3128],
  'El Centenario, BCS':       [24.0833, -110.4000],
  'La Ventana, BCS':          [24.0333, -109.9667],
  'Los Planes, BCS':          [23.9000, -109.9000],
  'Todos Santos, BCS':        [23.4500, -110.2167],
  'El Pescadero, BCS':        [23.3667, -110.1667],
  'Ciudad Constitución, BCS': [25.0414, -111.6586],
  'Ciudad Insurgentes, BCS':  [25.2833, -111.7667],
  'Comondú, BCS':             [26.0500, -111.8167],
  // BCS — Los Cabos y Corredor
  'Los Cabos, BCS':           [23.0545, -109.7022],
  'Cabo San Lucas, BCS':      [22.8897, -109.9167],
  'San José del Cabo, BCS':   [23.0631, -109.6906],
  'Los Barriles, BCS':        [23.6667, -109.6833],
  'Buena Vista, BCS':         [23.6500, -109.7167],
  'La Ribera, BCS':           [23.6167, -109.6500],
  'Miraflores, BCS':          [23.3667, -109.7667],
  'Santiago, BCS':            [23.4667, -109.7500],
  'El Triunfo, BCS':          [23.7833, -110.0833],
  'San Antonio, BCS':         [23.7333, -109.9167],
};

/**
 * Calcula las ciudades que caen "en línea" entre origen y destino.
 * Usa proyección geométrica en espacio lat/lng.
 * Tolerancia lateral: ~80 km (≈ 0.72 grados)
 */
export const calcCiudadesEnRuta = (origen, destino) => {
  const A = _COORDS_RUTA[origen];
  const B = _COORDS_RUTA[destino];
  if (!A || !B) return [];
  const dx = B[0] - A[0];
  const dy = B[1] - A[1];
  const len2 = dx * dx + dy * dy;
  const resultado = [];
  for (const [ciudad, C] of Object.entries(_COORDS_RUTA)) {
    if (ciudad === origen || ciudad === destino) continue;
    const cx = C[0] - A[0];
    const cy = C[1] - A[1];
    const t = len2 > 0 ? (cx * dx + cy * dy) / len2 : 0;
    if (t < 0.05 || t > 0.95) continue;
    const px = A[0] + t * dx - C[0];
    const py = A[1] + t * dy - C[1];
    const dist = Math.sqrt(px * px + py * py);
    if (dist < 0.72) resultado.push({ ciudad, t });
  }
  return resultado.sort((a, b) => a.t - b.t).map(x => x.ciudad);
};

// ============================================================
// ACTIONS - Operaciones cross-módulo
// ============================================================

/** Crear una notificación para un usuario o rol */
const _agregarNotif = (store, { destinatarioId, destinatarioRol, tipo, titulo, mensaje, datos }) => {
  const notif = {
    id: `NOTIF-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
    destinatarioId: destinatarioId || null,
    destinatarioRol: destinatarioRol || null,
    tipo,
    titulo,
    mensaje,
    datos: datos || {},
    leida: false,
    fecha: new Date().toISOString()
  };
  const TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 días
  const cutoff = new Date(Date.now() - TTL_MS).toISOString();
  const notificacionesLimpias = (store.notificaciones || []).filter(n => (n.creadoEn || n.fecha || '') >= cutoff);
  return [...notificacionesLimpias, notif];
};

/** Marcar notificaciones como leídas para un usuario */
export const marcarNotificacionesLeidas = (usuarioId, _rol) => {
  updateStore(store => ({
    ...store,
    notificaciones: (store.notificaciones || []).map(n =>
      n.destinatarioId === usuarioId ? { ...n, leida: true } : n
    )
  }));
};

/** Marcar como leídas todas las notificaciones de ciertos tipos para un usuario, manteniendo la más reciente sin leer */
export const deduplicarNotifsPorTipo = (usuarioId, tipos) => {
  updateStore(store => ({
    ...store,
    notificaciones: (() => {
      const todas = store.notificaciones || [];
      // Encontrar la notif más reciente de esos tipos para este usuario
      const candidatas = todas
        .filter(n => !n.leida && n.destinatarioId === usuarioId && tipos.includes(n.tipo))
        .sort((a, b) => new Date(b.creadoEn || b.fecha) - new Date(a.creadoEn || a.fecha));
      const keepId = candidatas[0]?.id; // la más reciente queda sin leer
      return todas.map(n =>
        !n.leida && n.destinatarioId === usuarioId && tipos.includes(n.tipo) && n.id !== keepId
          ? { ...n, leida: true }
          : n
      );
    })()
  }));
};

/** Eliminar todas las notificaciones de un usuario/rol */
export const limpiarNotificaciones = (usuarioId, _rol) => {
  updateStore(store => ({
    ...store,
    notificaciones: (store.notificaciones || []).filter(
      n => n.destinatarioId !== usuarioId
    )
  }));
};

/** Obtener notificaciones no leídas para un usuario */
export const getNotificacionesPendientes = (store, usuarioId, _rol) =>
  (store.notificaciones || []).filter(
    n => !n.leida && n.destinatarioId === usuarioId
  );

/** CLIENTE: Cancelar/eliminar una solicitud en cotización */
export const cancelarSolicitud = (solicitudId) => {
  updateStore(store => {
    const solicitud = (store.solicitudes || []).find(s => s.id === solicitudId);
    if (!solicitud) return store;

    // Transportistas que ya cotizaron esta solicitud
    const transportistasQueCotizaron = [
      ...new Set(
        (store.cotizaciones || [])
          .filter(c => c.solicitudId === solicitudId)
          .map(c => c.transportistaId)
          .filter(Boolean)
      )
    ];

    // Agregar notificación a cada transportista que ya cotizó
    let notificaciones = store.notificaciones || [];
    for (const transportistaId of transportistasQueCotizaron) {
      const notif = {
        id: `NOTIF-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
        destinatarioId: transportistaId,
        destinatarioRol: null,
        tipo: 'solicitud_cancelada',
        titulo: '❌ Solicitud cancelada por el cliente',
        mensaje: `La solicitud ${solicitudId} (${solicitud.origen} → ${solicitud.destino}) fue cancelada. Tu cotización ya no es válida.`,
        datos: { solicitudId },
        leida: false,
        fecha: new Date().toISOString(),
      };
      notificaciones = [...notificaciones, notif];
    }

    return {
      ...store,
      solicitudes: store.solicitudes.map(s =>
        s.id === solicitudId ? { ...s, status: 'cancelado' } : s
      ),
      // Marcar cotizaciones como canceladas en lugar de borrarlas,
      // para que los transportistas puedan ver el historial en "Cerradas"
      cotizaciones: (store.cotizaciones || []).map(c =>
        c.solicitudId === solicitudId ? { ...c, status: 'cancelada_cliente' } : c
      ),
      notificaciones,
    };
  });
};

/** SISTEMA: Expirar solicitudes cuya fecha de recogida ya pasó y notificar a cliente y transportistas */
export const expirarSolicitudesVencidas = () => {
  return updateStore(store => {
    const hoy = new Date().toISOString().slice(0, 10);
    const aExpirar = (store.solicitudes || []).filter(
      s => (s.status === 'abierta' || s.status === 'en_cotizacion') && s.fechaRecogida && s.fechaRecogida < hoy
    );
    if (aExpirar.length === 0) return store;

    let notificaciones = store.notificaciones || [];
    for (const sol of aExpirar) {
      // Evitar duplicar notificaciones si ya se generaron antes
      const yaNotificado = notificaciones.some(
        n => n.tipo === 'solicitud_expirada' && n.datos?.solicitudId === sol.id
      );
      if (yaNotificado) continue;

      // Notificar al cliente
      notificaciones = [...notificaciones, {
        id: `NOTIF-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
        destinatarioId: sol.clienteId,
        destinatarioRol: null,
        tipo: 'solicitud_expirada',
        titulo: '⏰ Solicitud expirada',
        mensaje: `Tu solicitud ${sol.id} (${sol.origen} → ${sol.destino}) expiró sin que aceptaras una cotización.`,
        datos: { solicitudId: sol.id },
        leida: false,
        fecha: new Date().toISOString(),
      }];

      // Notificar a cada transportista que ya cotizó
      const transportistasQueCotizaron = [
        ...new Set(
          (store.cotizaciones || [])
            .filter(c => c.solicitudId === sol.id)
            .map(c => c.transportistaId)
            .filter(Boolean)
        )
      ];
      for (const transportistaId of transportistasQueCotizaron) {
        notificaciones = [...notificaciones, {
          id: `NOTIF-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
          destinatarioId: transportistaId,
          destinatarioRol: null,
          tipo: 'solicitud_expirada_trans',
          titulo: '⏰ Solicitud expirada',
          mensaje: `La solicitud ${sol.id} (${sol.origen} → ${sol.destino}) expiró sin ser aceptada. Tu cotización ya no es válida.`,
          datos: { solicitudId: sol.id },
          leida: false,
          fecha: new Date().toISOString(),
        }];
      }
    }

    return {
      ...store,
      solicitudes: store.solicitudes.map(s =>
        aExpirar.find(e => e.id === s.id) ? { ...s, status: 'expirada' } : s
      ),
      cotizaciones: (store.cotizaciones || []).map(c =>
        aExpirar.find(e => e.id === c.solicitudId) && c.status === 'pendiente'
          ? { ...c, status: 'expirada' }
          : c
      ),
      notificaciones,
    };
  });
};

/** CLIENTE: Crear nueva solicitud de flete */
// Normaliza ciudad para comparación — ambos lados (empresa y solicitud) vienen de combobox
const _normStr = (str) => (str || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const _normCiudad = _normStr;

export const crearSolicitud = (clienteId, clienteNombre, datos) => {
  return updateStore(store => {
    const id = `SOL-${String(store.solicitudes.length + 1).padStart(3, '0')}`;
    const nueva = {
      id,
      clienteId,
      clienteNombre,
      ...datos,
      status: 'cotizando',
      fechaCreacion: new Date().toISOString(),
      cotizacionesRecibidas: 0,
      maxCotizaciones: 10,
      aceptaCotizaciones: true
    };
    const difusionGlobal = !!store.configPlataforma?.difusionGlobal;
    const ciudadOrigen = _normCiudad(datos.origen); // texto libre del cliente → extraer ciudad
    const todasLasEmpresas = store.empresasActivas || [];
    const empresasLocales = todasLasEmpresas.filter(e => {
      const ciudadE = _normStr(e.ciudad); // campo ciudad del combobox → ya es limpio
      return ciudadE && ciudadOrigen && (ciudadE.includes(ciudadOrigen) || ciudadOrigen.includes(ciudadE));
    });
    // En difusión global: notificar a todos los transportistas activos.
    // En modo normal: notificar solo a los del origen (Fase 1). Fases 2 y 3 por polling.
    const empresasANotificar = difusionGlobal ? todasLasEmpresas : empresasLocales;
    let notificaciones = store.notificaciones || [];
    const usuariosTransp = (store.usuarios || []).filter(u => u.rol === 'transportista');
    empresasANotificar.forEach(empresa => {
      const u = usuariosTransp.find(u => u.empresaId === empresa.id);
      if (u) {
        const esLocal = empresasLocales.some(e => e.id === empresa.id);
        notificaciones = _agregarNotif({ ...store, notificaciones }, {
          destinatarioId: u.id,
          tipo: 'nueva_solicitud',
          titulo: esLocal ? '🚚 ¡Nueva solicitud en tu zona!' : '🚚 Nueva solicitud disponible',
          mensaje: `${clienteNombre} solicita flete de ${datos.origen || ''} a ${datos.destino || ''}`,
          datos: { solicitudId: id }
        });
      }
    });
    return { ...store, solicitudes: [...store.solicitudes, nueva], notificaciones };
  });
};

/** TRANSPORTISTA: Enviar cotización para una solicitud */
export const enviarCotizacion = (transportistaId, empresaId, transportistaNombre, solicitudId, datosCotizacion) => {
  return updateStore(store => {
    const id = `COT-${String(store.cotizaciones.length + 1).padStart(3, '0')}`;
    const nueva = {
      id,
      solicitudId,
      transportistaId,
      empresaId,
      transportistaNombre,
      ...datosCotizacion,
      fechaCreacion: new Date().toISOString(),
      status: 'pendiente'
    };
    const cotizaciones = [...store.cotizaciones, nueva];
    // Actualizar contador de cotizaciones en la solicitud
    const solicitud = (store.solicitudes || []).find(s => s.id === solicitudId);
    const solicitudes = store.solicitudes.map(s =>
      s.id === solicitudId
        ? { ...s, cotizacionesRecibidas: (s.cotizacionesRecibidas || 0) + 1 }
        : s
    );
    // Notificar al cliente que recibió una cotización
    const notificaciones = solicitud
      ? _agregarNotif(store, {
          destinatarioId: solicitud.clienteId,
          tipo: 'nueva_cotizacion',
          titulo: '¡Recibiste una cotización!',
          mensaje: `${transportistaNombre} cotizó tu solicitud con precio $${datosCotizacion.precio?.toLocaleString('es-MX') || '--'}`,
          datos: { solicitudId, cotizacionId: id }
        })
      : (store.notificaciones || []);
    return { ...store, cotizaciones, solicitudes, notificaciones };
  });
};

/** CLIENTE: Aceptar cotización y crear viaje activo */
export const aceptarCotizacion = (cotizacionId, solicitudId, metodoPago) => {
  return updateStore(store => {
    const cotizacion = store.cotizaciones.find(c => c.id === cotizacionId);
    const solicitud = store.solicitudes.find(s => s.id === solicitudId);
    if (!cotizacion || !solicitud) return store;

    const viajeId = `VJ-${String(store.viajes.length + 1).padStart(3, '0')}`;
    const nuevoViaje = {
      id: viajeId,
      solicitudId,
      clienteId: solicitud.clienteId,
      cotizacionId,
      transportistaId: cotizacion.transportistaId,
      empresaId: cotizacion.empresaId,
      transportistaNombre: cotizacion.transportistaNombre,
      origen: solicitud.origen,
      destino: solicitud.destino,
      origenDir: solicitud.origenDir || solicitud.origen,
      destinoDir: solicitud.destinoDir || solicitud.destino,
      origenCoords: solicitud.origenCoords || null,
      destinoCoords: solicitud.destinoCoords || null,
      carga: solicitud.carga,
      peso: solicitud.peso,
      costo: cotizacion.precio,
      costoFinal: cotizacion.precio,
      metodoPago,
      pagado: true,
      status: 'pendiente_asignar',
      progreso: 0,
      eta: cotizacion.tiempoEntrega,
      prioridad: solicitud.prioridad || 'normal',
      fechaCreacion: new Date().toISOString()
    };

    const solicitudes = store.solicitudes.map(s =>
      s.id === solicitudId ? { ...s, status: 'asignado' } : s
    );

    const cotizaciones = store.cotizaciones.map(c =>
      c.id === cotizacionId ? { ...c, status: 'ganadora' } : c.solicitudId === solicitudId ? { ...c, status: 'perdida' } : c
    );

    const notificaciones = _agregarNotif(store, {
      destinatarioId: cotizacion.transportistaId,
      tipo: 'cotizacion_ganadora',
      titulo: '🏆 ¡Ganaste la subasta!',
      mensaje: `${solicitud.clienteNombre} aceptó tu cotización de $${cotizacion.precio?.toLocaleString('es-MX') || '--'} y realizó el pago. Ruta: ${solicitud.origen} → ${solicitud.destino}`,
      datos: { viajeId, solicitudId, cotizacionId }
    });

    return {
      ...store,
      viajes: [...store.viajes, nuevoViaje],
      solicitudes,
      cotizaciones,
      notificaciones,
    };
  });
};

/** TRANSPORTISTA: Asignar viaje a un chofer */
export const asignarViajeAChofer = (viajeId, choferId, choferEmail, choferNombre, unidad, empresaId, instrucciones = '', viajeData = null) => {
  return updateStore(store => {
    const viaje = store.viajes.find(v => v.id === viajeId) || viajeData;
    if (!viaje) return store;

    const ordenId = `OT-${String(store.ordenesChofer.length + 1).padStart(3, '0')}`;
    const nuevaOrden = {
      id: ordenId,
      choferId,
      choferEmail,
      viajeId,
      empresaId,
      cliente: viaje.clienteId,
      contactoCliente: '',
      telefonoCliente: '',
      origen: viaje.origen,
      destino: viaje.destino,
      origenDir: viaje.origenDir,
      destinoDir: viaje.destinoDir,
      origenCoords: viaje.origenCoords || null,
      destinoCoords: viaje.destinoCoords || null,
      carga: viaje.carga,
      peso: `${viaje.peso} tons`,
      tipoUnidad: unidad,
      unidad,
      fechaRecogida: new Date().toISOString().split('T')[0],
      horaRecogida: '08:00',
      distancia: 'Ver mapa',
      tiempoEstimado: viaje.eta || 'Ver mapa',
      instrucciones,
      status: 'asignada',
      prioridad: viaje.prioridad || 'normal',
      fechaCreacion: new Date().toISOString()
    };

    const viajes = store.viajes.map(v =>
      v.id === viajeId ? { ...v, choferId, choferNombre, unidad, status: 'en_proceso' } : v
    );

    const notificaciones = _agregarNotif(store, {
      destinatarioId: choferId,
      tipo: 'orden_asignada',
      titulo: '🚛 Nueva orden asignada',
      mensaje: `Se te asignó una nueva orden de flete. Ruta: ${viaje.origen} → ${viaje.destino}. Carga: ${viaje.carga}.`,
      datos: { ordenId, viajeId }
    });

    return { ...store, ordenesChofer: [...store.ordenesChofer, nuevaOrden], viajes, notificaciones };
  });
};

/** CHOFER: Actualizar status de una orden */
export const actualizarStatusOrden = (ordenId, nuevoStatus) => {
  const progresoMap = {
    'aceptada': 0, 'en_camino_recogida': 10, 'cargando': 25,
    'en_ruta': 50, 'llegada_destino': 75, 'descargando': 90, 'completada': 100
  };
  const checkpointLabel = {
    'en_camino_recogida': 'Orden iniciada',
    'cargando': 'Llegada al origen',
    'en_ruta': 'Carga completada - En ruta',
    'llegada_destino': 'Llegada al destino',
    'completada': 'Entrega completada'
  };
  const hora = new Date().toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' });

  return updateStore(store => {
    const ordenesChofer = store.ordenesChofer.map(o => {
      if (o.id !== ordenId) return o;
      const checkpoints = [
        ...(o.checkpoints || []),
        ...(checkpointLabel[nuevoStatus] ? [{ paso: checkpointLabel[nuevoStatus], hora, completado: true }] : [])
      ];
      return { ...o, status: nuevoStatus, progreso: progresoMap[nuevoStatus] ?? o.progreso, checkpoints };
    });

    // Sincronizar con viaje activo si existe
    const orden = store.ordenesChofer.find(o => o.id === ordenId);
    let viajes = store.viajes;
    if (orden?.viajeId) {
      const progresoMapViaje = {
        'aceptada': 10, 'en_camino_recogida': 20, 'cargando': 40,
        'en_ruta': 60, 'llegada_destino': 80, 'descargando': 90, 'completada': 100
      };
      viajes = store.viajes.map(v => {
        if (v.id !== orden.viajeId) return v;
        const extra = {};
        if (nuevoStatus === 'completada') {
          extra.fechaCompletada = new Date().toISOString();
          // No calcular comisión aquí — se libera hasta que el cliente confirme la entrega
        }
        return { ...v, status: nuevoStatus, progreso: progresoMapViaje[nuevoStatus] ?? v.progreso, ...extra };
      });
    }
    // Notificar al cliente en hitos clave
    const notifClienteMsgs = {
      'en_camino_recogida': { titulo: '🚗 El chofer va en camino', mensaje: `El chofer está en camino al punto de recogida.` },
      'cargando':           { titulo: '📦 El chofer llegó al origen', mensaje: `El chofer llegó al punto de recogida y está cargando la mercancía.` },
      'en_ruta':            { titulo: '🚛 Tu carga está en camino', mensaje: `El chofer recogió la carga y va en ruta hacia el destino.` },
      'llegada_destino':    { titulo: '📍 El chofer llegó al destino', mensaje: `Tu carga está siendo entregada. Prepárate para confirmar la recepción.` },
      'completada':         { titulo: '✅ Entrega realizada', mensaje: `Tu carga fue entregada exitosamente. Por favor confirma la recepción.` },
    };
    let notificaciones = store.notificaciones || [];
    if (orden?.viajeId && notifClienteMsgs[nuevoStatus]) {
      const viaje = store.viajes.find(v => v.id === orden.viajeId);
      if (viaje?.clienteId) {
        notificaciones = _agregarNotif({ ...store, notificaciones }, {
          destinatarioId: viaje.clienteId,
          tipo: `status_${nuevoStatus}`,
          titulo: notifClienteMsgs[nuevoStatus].titulo,
          mensaje: notifClienteMsgs[nuevoStatus].mensaje,
          datos: { viajeId: orden.viajeId, ordenId }
        });
      }
      // Notificar también al transportista cuando se completa
      if (nuevoStatus === 'completada' && viaje?.transportistaId) {
        notificaciones = _agregarNotif({ ...store, notificaciones }, {
          destinatarioId: viaje.transportistaId,
          tipo: 'orden_completada_chofer',
          titulo: '🏁 Chofer completó la entrega',
          mensaje: `La orden ${ordenId} fue completada. Ruta: ${orden.origen} → ${orden.destino}.`,
          datos: { viajeId: orden.viajeId, ordenId }
        });
      }
    }
    // Notificar al cliente de un retorno cuando el chofer actualiza el status
    if (orden?.esRetorno && orden.retornoId && notifClienteMsgs[nuevoStatus]) {
      const retorno = (store.retornosVacios || []).find(r => r.id === orden.retornoId);
      const ofertaAceptada = (retorno?.ofertas || []).find(o => o.status === 'aceptada');
      if (ofertaAceptada?.clienteId) {
        notificaciones = _agregarNotif({ ...store, notificaciones }, {
          destinatarioId: ofertaAceptada.clienteId,
          tipo: `retorno_status_${nuevoStatus}`,
          titulo: notifClienteMsgs[nuevoStatus].titulo,
          mensaje: notifClienteMsgs[nuevoStatus].mensaje,
          datos: { retornoId: orden.retornoId, ordenId }
        });
      }
    }
    return { ...store, ordenesChofer, viajes, notificaciones };
  });
};

/** CHOFER: Reportar incidencia en una orden activa */
export const reportarIncidencia = (ordenId, { tipo, descripcion, foto }) => {
  return updateStore(store => {
    const orden = store.ordenesChofer.find(o => o.id === ordenId);
    if (!orden) return store;

    const incidencia = {
      id: `INC-${Date.now()}`,
      ordenId,
      tipo,
      descripcion,
      foto: foto || null,
      fecha: new Date().toISOString(),
      choferNombre: orden.choferNombre || orden.choferEmail || 'Chofer',
    };

    // Agregar incidencia a la orden y cambiar status (guardar status anterior para reanudar)
    const ordenesChofer = store.ordenesChofer.map(o =>
      o.id !== ordenId ? o : {
        ...o,
        statusAnterior: o.status,
        status: 'incidencia',
        incidencias: [...(o.incidencias || []), incidencia],
      }
    );

    // Sincronizar status en viaje activo
    const viajes = orden.viajeId
      ? store.viajes.map(v => v.id === orden.viajeId ? { ...v, status: 'incidencia' } : v)
      : store.viajes;

    // Notificar al transportista
    const viaje = orden.viajeId ? store.viajes.find(v => v.id === orden.viajeId) : null;
    const destinatarioId = viaje?.transportistaId || null;
    const tiposLabel = {
      mecanica: 'Falla mecánica', accidente: 'Accidente vial', clima: 'Condiciones climáticas',
      carga: 'Problema con la carga', direccion: 'Dirección incorrecta',
      cliente: 'Cliente no disponible', otro: 'Otro',
    };

    let notificaciones = store.notificaciones || [];
    if (destinatarioId) {
      notificaciones = _agregarNotif({ ...store, notificaciones }, {
        destinatarioId,
        tipo: 'incidencia_reportada',
        titulo: `⚠️ Incidencia: ${tiposLabel[tipo] || tipo}`,
        mensaje: `Orden ${ordenId} (${orden.origen} → ${orden.destino}): ${descripcion}`,
        datos: { ordenId, viajeId: orden.viajeId, incidenciaId: incidencia.id },
      });
    }
    return { ...store, ordenesChofer, viajes, notificaciones };
  });
};

/** TRANSPORTISTA: Compartir evidencia de entrega con el cliente */
export const compartirEvidenciaConCliente = (viajeId, evidencia) => {
  return updateStore(store => {
    const viaje = store.viajes.find(v => v.id === viajeId);
    if (!viaje || !viaje.clienteId) return store;
    const notificaciones = _agregarNotif(store, {
      destinatarioId: viaje.clienteId,
      tipo: 'evidencia_entrega',
      titulo: '📸 Evidencia de tu flete',
      mensaje: `Tu transportista compartió una evidencia: ${evidencia.nombre}`,
      datos: { viajeId, foto: evidencia.url || evidencia.base64, nombre: evidencia.nombre },
    });
    return { ...store, notificaciones };
  });
};

/** TRANSPORTISTA: Compartir incidencia con el cliente */
export const compartirIncidenciaConCliente = (viajeId, incidenciaId) => {
  return updateStore(store => {
    const viaje = store.viajes.find(v => v.id === viajeId);
    const orden = (store.ordenesChofer || []).find(o => o.viajeId === viajeId);
    if (!viaje || !viaje.clienteId || !orden) return store;
    const incidencia = (orden.incidencias || []).find(i => i.id === incidenciaId);
    if (!incidencia) return store;
    const tiposLabel = {
      mecanica: 'Falla mecánica', accidente: 'Accidente vial', clima: 'Condiciones climáticas',
      carga: 'Problema con la carga', direccion: 'Dirección incorrecta',
      cliente: 'Cliente no disponible', otro: 'Otro',
    };
    const notificaciones = _agregarNotif(store, {
      destinatarioId: viaje.clienteId,
      tipo: 'incidencia_cliente',
      titulo: `⚠️ Incidencia en tu flete`,
      mensaje: `${tiposLabel[incidencia.tipo] || incidencia.tipo}: ${incidencia.descripcion}`,
      datos: { viajeId, incidenciaId, foto: incidencia.foto || null },
    });
    return { ...store, notificaciones };
  });
};

/** CHOFER: Reanudar orden después de una incidencia */
export const reanudarOrdenChofer = (ordenId) => {
  return updateStore(store => {
    const orden = store.ordenesChofer.find(o => o.id === ordenId);
    if (!orden || orden.status !== 'incidencia') return store;
    const statusPrevio = orden.statusAnterior || 'en_ruta';
    const ordenesChofer = store.ordenesChofer.map(o =>
      o.id !== ordenId ? o : { ...o, status: statusPrevio, statusAnterior: null }
    );
    const viajes = orden.viajeId
      ? store.viajes.map(v => v.id === orden.viajeId ? { ...v, status: statusPrevio } : v)
      : store.viajes;
    const viaje = orden.viajeId ? store.viajes.find(v => v.id === orden.viajeId) : null;
    const destinatarioId = viaje?.transportistaId || null;
    let notificaciones = store.notificaciones || [];
    if (destinatarioId) {
      notificaciones = _agregarNotif({ ...store, notificaciones }, {
        destinatarioId,
        tipo: 'incidencia_resuelta',
        titulo: '✅ Incidencia resuelta',
        mensaje: `El chofer reanudó la orden ${ordenId} (${orden.origen} → ${orden.destino}). El viaje continúa normalmente.`,
        datos: { ordenId, viajeId: orden.viajeId },
      });
    }
    return { ...store, ordenesChofer, viajes, notificaciones };
  });
};

/** CHOFER: Completar orden y moverla al historial */
export const completarOrdenChofer = (ordenId, evidencias = [], firma = null) => {
  return updateStore(store => {
    const orden = store.ordenesChofer.find(o => o.id === ordenId);
    if (!orden) return store;

    const viaje = orden.viajeId ? store.viajes.find(v => v.id === orden.viajeId) : null;
    const entrada = {
      id: orden.id,
      fecha: new Date().toISOString().split('T')[0],
      ruta: `${orden.origen} → ${orden.destino}`,
      cliente: orden.cliente,
      calificacionRecibida: null,
      status: 'completada',
      choferId: orden.choferId,
      choferEmail: orden.choferEmail || null,
      empresaId: orden.empresaId,
      viajeId: orden.viajeId || null,
      evidencias: evidencias || [],
      firma: firma || null,
      precio: viaje?.costoFinal || viaje?.precio || 0,
    };

    // Para retornos: mantener la orden en ordenesChofer con status 'completada' hasta que el cliente confirme
    const ordenesChofer = orden.esRetorno
      ? store.ordenesChofer.map(o => o.id === ordenId ? { ...o, status: 'completada', progreso: 100 } : o)
      : store.ordenesChofer.filter(o => o.id !== ordenId);
    const historialEntregas = [...store.historialEntregas, entrada];

    // Resetear status del chofer a 'disponible' solo si ya no tiene más órdenes activas
    const ordenesActivasRestantes = ordenesChofer.filter(o =>
      (o.choferId === orden.choferId || o.choferEmail === orden.choferEmail) &&
      !['completada', 'cancelada'].includes(o.status)
    ).length;
    const plantillaChoferes = (store.plantillaChoferes || []).map(c => {
      if (c.id !== orden.choferId && c.email !== orden.choferEmail) return c;
      return ordenesActivasRestantes === 0 ? { ...c, status: 'disponible', rutaActual: null } : c;
    });

    // Si hay viaje vinculado, marcarlo como completada
    let viajes = store.viajes;
    if (orden.viajeId) {
      viajes = store.viajes.map(v =>
        v.id === orden.viajeId
          ? { ...v, status: 'completada', progreso: 100, fechaCompletada: v.fechaCompletada || new Date().toISOString(), evidenciasEntrega: evidencias || [] }
          : v
      );
    }

    let notificaciones = store.notificaciones || [];
    // Notificar al transportista
    const transportistaId = orden.transportistaId
      || store.usuarios.find(u => u.empresaId === orden.empresaId && u.rol === 'transportista')?.id
      || null;
    if (transportistaId) {
      notificaciones = _agregarNotif({ ...store, notificaciones }, {
        destinatarioId: transportistaId,
        tipo: 'entrega_completada',
        titulo: '📦 Entrega completada',
        mensaje: `El chofer completó la entrega. Ruta: ${orden.origen} → ${orden.destino}. Pendiente confirmación del cliente.`,
        datos: { ordenId, viajeId: orden.viajeId, retornoId: orden.retornoId }
      });
    }
    // Notificar al cliente del retorno
    if (orden.esRetorno && orden.retornoId) {
      const retorno = (store.retornosVacios || []).find(r => r.id === orden.retornoId);
      const ofertaAceptada = (retorno?.ofertas || []).find(o => o.status === 'aceptada');
      if (ofertaAceptada?.clienteId) {
        notificaciones = _agregarNotif({ ...store, notificaciones }, {
          destinatarioId: ofertaAceptada.clienteId,
          tipo: 'retorno_status_completada',
          titulo: '✅ Entrega realizada',
          mensaje: `Tu carga fue entregada exitosamente. Por favor confirma la recepción.`,
          datos: { retornoId: orden.retornoId, ordenId }
        });
      }
    }
    const resultado = { ...store, ordenesChofer, historialEntregas, viajes, notificaciones, plantillaChoferes };

    // ── Red de mercadeo: procesar comisiones por flete completado ──
    if (orden.viajeId && orden.empresaId) {
      const viajeCompletado = viajes.find(v => v.id === orden.viajeId);
      const empresa = (resultado.empresasActivas || []).find(e => e.id === orden.empresaId);
      const cadena = empresa?.cadenaReferidos || [];
      const cfg = resultado.configPlataforma?.redMercadeo;

      if (cfg?.habilitada && cadena.length > 0 && viajeCompletado) {
        const comisionChoyero = (viajeCompletado.costoFinal || viajeCompletado.precio || 0)
          * ((empresa?.comisionPersonalizada ?? cfg.comisionBasico ?? 20) / 100);

        if (comisionChoyero > 0) {
          const pcts = [cfg.pctFleteN1 / 100, cfg.pctFleteN2 / 100, cfg.pctFleteN3 / 100];
          const ahora = new Date().toISOString();
          const nuevasComisionesF = cadena.map((userId, idx) => ({
            id: `COM-F-${Date.now()}-N${idx + 1}`,
            fecha: ahora, tipo: 'flete', status: 'disponible', nivel: idx + 1,
            userId: userId, empresaId: orden.empresaId,
            origenFleteId: orden.viajeId,
            monto: Math.round(comisionChoyero * (pcts[idx] || 0)),
            scoreRiesgo: 0, flagsRiesgo: [], fechaLiberacion: ahora, fechaExpiracion: null,
          })).filter(c => c.monto > 0);

          // Primer flete: liberar comisiones de registro pendientes
          let comisionesRed = [...(resultado.comisionesRed || []), ...nuevasComisionesF];
          if (!empresa?.primerFleteCompletado) {
            const pendientes = comisionesRed.filter(
              c => c.empresaId === orden.empresaId && c.status === 'pendiente'
            );
            comisionesRed = comisionesRed.map(c => {
              if (c.empresaId === orden.empresaId && c.status === 'pendiente') {
                return { ...c, status: 'disponible', fechaLiberacion: ahora };
              }
              return c;
            });
          }

          // Notificar a cada beneficiario de la red
          let notificacionesConComision = resultado.notificaciones || [];
          nuevasComisionesF.forEach(com => {
            notificacionesConComision = _agregarNotif({ notificaciones: notificacionesConComision }, {
              destinatarioId: com.userId,
              tipo: 'comision_red',
              titulo: '💰 Nueva comisión acreditada',
              mensaje: `Ganaste $${com.monto.toLocaleString()} MXN (N${com.nivel}) por flete completado de tu red. Ya está disponible para retiro.`,
              datos: { comisionId: com.id, monto: com.monto, nivel: com.nivel },
            });
          });

          return {
            ...resultado,
            comisionesRed,
            notificaciones: notificacionesConComision,
            empresasActivas: (resultado.empresasActivas || []).map(e =>
              e.id === orden.empresaId ? { ...e, primerFleteCompletado: true } : e
            ),
          };
        }
      }
    }

    return resultado;
  });
};

/** TRANSPORTISTA: Agregar unidad a su flota */
export const agregarUnidadFlota = (empresaId, datos) => {
  return updateStore(store => {
    const id = `UN-${Date.now()}`;
    const nueva = { ...datos, id, empresaId, kmRecorridos: 0 };
    const flotaActual = store.flota || initialState.flota;
    return { ...store, flota: [...flotaActual, nueva] };
  });
};

/** TRANSPORTISTA: Actualizar unidad */
export const actualizarUnidadFlota = (unidadId, datos) => {
  return updateStore(store => {
    const flotaActual = store.flota || initialState.flota;
    return { ...store, flota: flotaActual.map(u => u.id === unidadId ? { ...u, ...datos } : u) };
  });
};

/** TRANSPORTISTA: Eliminar unidad */
export const eliminarUnidadFlota = (unidadId) => {
  return updateStore(store => {
    const flotaActual = store.flota || initialState.flota;
    return { ...store, flota: flotaActual.filter(u => u.id !== unidadId) };
  });
};

/** CHOFER: Actualizar datos de perfil (teléfono, etc.) */
export const actualizarPerfilChofer = (userId, datos) => {
  return updateStore(store => {
    const usuarioActual = (store.usuarios || []).find(u => u.id === userId);
    const usuarios = (store.usuarios || []).map(u =>
      u.id === userId ? { ...u, ...datos } : u
    );
    const plantillaChoferes = (store.plantillaChoferes || []).map(c =>
      c.email === usuarioActual?.email ? { ...c, telefono: datos.telefono || c.telefono } : c
    );
    return { ...store, usuarios, plantillaChoferes };
  });
};

/** TRANSPORTISTA: Agregar chofer a su plantilla */
export const agregarChoferPlantilla = (empresaId, datos) => {
  return updateStore(store => {
    const lista = store.plantillaChoferes || initialState.plantillaChoferes;
    const nuevo = { ...datos, empresaId, id: `CH-${Date.now()}` };
    return { ...store, plantillaChoferes: [...lista, nuevo] };
  });
};

/** TRANSPORTISTA: Actualizar chofer de su plantilla */
export const actualizarChoferPlantilla = (choferId, datos) => {
  return updateStore(store => {
    const lista = store.plantillaChoferes || initialState.plantillaChoferes;
    return { ...store, plantillaChoferes: lista.map(c => c.id === choferId ? { ...c, ...datos } : c) };
  });
};

/** TRANSPORTISTA: Eliminar chofer de su plantilla */
export const eliminarChoferPlantilla = (choferId) => {
  return updateStore(store => {
    const lista = store.plantillaChoferes || initialState.plantillaChoferes;
    return { ...store, plantillaChoferes: lista.filter(c => c.id !== choferId) };
  });
};

/** TRANSPORTISTA: Asignar chofer a unidad (bidireccional).
 *  Pasar unidadId=null para desasignar el chofer de su unidad actual.
 *  Pasar choferId=null para desasignar la unidad de su chofer actual.
 */
export const asignarChoferAUnidad = (choferId, unidadId) => {
  return updateStore(store => {
    const flota = (store.flota || []).map(u => {
      if (u.id === unidadId) return { ...u, choferAsignado: choferId || null };
      if (choferId && u.choferAsignado === choferId) return { ...u, choferAsignado: null };
      return u;
    });
    const plantillaChoferes = (store.plantillaChoferes || []).map(c => {
      if (c.id === choferId) return { ...c, unidadAsignada: unidadId || null };
      if (unidadId && c.unidadAsignada === unidadId) return { ...c, unidadAsignada: null };
      return c;
    });
    return { ...store, flota, plantillaChoferes };
  });
};

/** CLIENTE: Confirmar recepción de entrega */
export const confirmarEntregaCliente = (viajeId) => {
  return updateStore(store => {
    const viaje = store.viajes.find(v => v.id === viajeId);
    if (!viaje) return store;

    const hora = new Date().toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' });
    const viajes = store.viajes.map(v => {
      if (v.id !== viajeId) return v;
      const fecha = v.fechaCompletada || new Date().toISOString();
      const extra = v.comisionPlataforma !== undefined ? {} : (() => {
        const empresa = store.empresasActivas.find(e => e.id === v.empresaId);
        const pct = empresa?.comisionPersonalizada ?? 20;
        const com = Math.round((v.costo || 0) * pct / 100);
        return { comisionPlataforma: com, gananciaTransportista: (v.costo || 0) - com };
      })();
      return { ...v, status: 'entrega_confirmada', clienteConfirmo: true, horaConfirmacion: hora, fechaCompletada: fecha, ...extra };
    });

    // Marcar la solicitud como completada para que salga de "Mis Solicitudes"
    const solicitudes = store.solicitudes.map(s =>
      s.id === viaje.solicitudId ? { ...s, status: 'completado' } : s
    );

    // Incrementar viajesCompletados en la empresa
    const empresasActivas = store.empresasActivas.map(e =>
      e.id === viaje.empresaId
        ? { ...e, viajesCompletados: (e.viajesCompletados || 0) + 1 }
        : e
    );

    let notificaciones = _agregarNotif(store, {
      destinatarioId: viaje.transportistaId,
      tipo: 'entrega_confirmada',
      titulo: '✅ Entrega confirmada por el cliente',
      mensaje: `El cliente confirmó la recepción de la carga. Ruta: ${viaje.origen} → ${viaje.destino}. Tu pago ha sido liberado.`,
      datos: { viajeId }
    });

    const clienteUser = store.usuarios.find(u => u.id === viaje.clienteId);
    let usuarios = store.usuarios;

    // ── Red de mercadeo: primer flete del cliente moral → liberar bonos de registro pendientes ──
    let comisionesRed = store.comisionesRed || [];
    if (clienteUser && clienteUser.tipoPersona === 'moral' && !clienteUser.primerFleteCompletado) {
      const ahora = new Date().toISOString();
      const pendientesCliente = comisionesRed.filter(
        c => c.empresaId === viaje.clienteId && c.status === 'pendiente'
      );
      if (pendientesCliente.length > 0) {
        comisionesRed = comisionesRed.map(c =>
          c.empresaId === viaje.clienteId && c.status === 'pendiente'
            ? { ...c, status: 'disponible', fechaLiberacion: ahora }
            : c
        );
        // Notificar a cada beneficiario
        pendientesCliente.forEach(com => {
          notificaciones = _agregarNotif({ notificaciones }, {
            destinatarioId: com.userId,
            tipo: 'comision_red',
            titulo: '🎉 Bono de registro liberado',
            mensaje: `Tu bono de $${com.monto.toLocaleString()} MXN (N${com.nivel}) está disponible — tu cliente referido completó su primer flete.`,
            datos: { comisionId: com.id, monto: com.monto, nivel: com.nivel },
          });
        });
        // Marcar primer flete del cliente
        usuarios = usuarios.map(u =>
          u.id === viaje.clienteId ? { ...u, primerFleteCompletado: true } : u
        );
      }
    }

    // ── Red de mercadeo: comisión recurrente por flete del CLIENTE MORAL ──
    const cfg = store.configPlataforma?.redMercadeo;
    if (cfg?.habilitada && clienteUser && clienteUser.tipoPersona === 'moral') {
      const cadenaCliente = clienteUser.cadenaReferidos || [];
      if (cadenaCliente.length > 0) {
        const empresaTransp = empresasActivas.find(e => e.id === viaje.empresaId);
        const pctComision = empresaTransp?.comisionPersonalizada ?? cfg.comisionBasico ?? 20;
        const comisionChoyero = Math.round((viaje.costo || 0) * pctComision / 100);
        if (comisionChoyero > 0) {
          const pcts = [cfg.pctFleteClienteN1 / 100, cfg.pctFleteClienteN2 / 100, cfg.pctFleteClienteN3 / 100];
          const ahora = new Date().toISOString();
          const nuevasComisiones = cadenaCliente.map((uid, idx) => ({
            id: `COM-FC-${Date.now()}-N${idx + 1}`,
            fecha: ahora,
            tipo: 'flete_cliente',
            status: 'disponible',
            nivel: idx + 1,
            userId: uid,
            empresaId: viaje.clienteId,
            origenFleteId: viajeId,
            monto: Math.round(comisionChoyero * (pcts[idx] || 0)),
            scoreRiesgo: 0,
            flagsRiesgo: [],
            fechaLiberacion: ahora,
            fechaExpiracion: null,
          })).filter(c => c.monto > 0);

          nuevasComisiones.forEach(com => {
            notificaciones = _agregarNotif({ notificaciones }, {
              destinatarioId: com.userId,
              tipo: 'comision_red',
              titulo: '💰 Nueva comisión acreditada',
              mensaje: `Ganaste $${com.monto.toLocaleString()} MXN (N${com.nivel}) por flete de tu cliente referido. Ya disponible para retiro.`,
              datos: { comisionId: com.id, monto: com.monto, nivel: com.nivel },
            });
          });

          return {
            ...store, viajes, solicitudes, empresasActivas, notificaciones, usuarios,
            comisionesRed: [...comisionesRed, ...nuevasComisiones],
          };
        }
      }
    }

    return { ...store, viajes, solicitudes, empresasActivas, notificaciones, usuarios, comisionesRed };
  });
};

/** SUPERADMIN: Guardar insignias manuales de una empresa activa */
export const actualizarInsigniasManuales = (empresaId, insignias) => {
  return updateStore(store => {
    const empresasActivas = store.empresasActivas.map(e =>
      e.id === empresaId ? { ...e, insigniasManuales: insignias } : e
    );
    return { ...store, empresasActivas };
  });
};

/** SUPERADMIN: Asignar plan (basico/pro) a una empresa */
export const asignarPlanEmpresa = (empresaId, plan) => {
  return updateStore(store => ({
    ...store,
    empresasActivas: store.empresasActivas.map(e =>
      e.id === empresaId ? { ...e, plan } : e
    )
  }));
};

/** TRANSPORTISTA: Pagar suscripción PRO (auto-aprobación) */
export const pagarSuscripcionPro = (empresaId, datosPago) => {
  return updateStore(store => ({
    ...store,
    empresasActivas: store.empresasActivas.map(e =>
      e.id === empresaId ? {
        ...e,
        plan: 'pro',
        suscripcionPro: {
          fechaInicio: new Date().toISOString(),
          fechaRenovacion: new Date(Date.now() + 30 * 86400000).toISOString(),
          ultimoPago: datosPago
        }
      } : e
    )
  }));
};

/** CLIENTE: Guardar plantilla de ruta frecuente */
export const guardarPlantillaRuta = (clienteId, plantilla) => {
  return updateStore(store => {
    const plantillas = store.plantillasRutas || [];
    const id = `PR-${Date.now()}`;
    return { ...store, plantillasRutas: [...plantillas, { ...plantilla, id, clienteId, creadoEn: new Date().toISOString() }] };
  });
};

/** CLIENTE: Eliminar plantilla de ruta */
export const eliminarPlantillaRuta = (plantillaId) => {
  return updateStore(store => ({
    ...store,
    plantillasRutas: (store.plantillasRutas || []).filter(p => p.id !== plantillaId)
  }));
};


/** SUPERADMIN: Actualizar configuración de planes (horasExclusivaPro, comisionPro, comisionBasico) */
export const actualizarConfigPlan = (cambios) => {
  return updateStore(store => ({
    ...store,
    configPlataforma: { ...store.configPlataforma, ...cambios }
  }));
};

/** SUPERADMIN: Actualizar comisión personalizada de una empresa activa */
export const actualizarComisionEmpresa = (empresaId, nuevaComision, nuevaComisionRetornos) => {
  return updateStore(store => {
    // Antes de cambiar el %, hacer snapshot de todos los viajes completados
    // de esta empresa que no tengan snapshot, usando el % ACTUAL (viejo).
    // Así el histórico queda congelado y solo los viajes futuros usan el nuevo %.
    const empresa = store.empresasActivas.find(e => e.id === empresaId);
    const pctActual = empresa?.comisionPersonalizada ?? 20;

    const viajes = store.viajes.map(v => {
      if (v.empresaId !== empresaId) return v;
      if (v.status !== 'completada' && v.status !== 'confirmado') return v;
      if (v.comisionPlataforma !== undefined) return v;
      const monto = v.costoFinal || v.precio || v.costo || 0;
      const com = Math.round(monto * pctActual / 100);
      return { ...v, comisionPlataforma: com, gananciaTransportista: monto - com };
    });

    const empresasActivas = store.empresasActivas.map(e => {
      if (e.id !== empresaId) return e;
      const updated = { ...e, comisionPersonalizada: nuevaComision };
      if (nuevaComisionRetornos !== undefined) updated.comisionRetornos = nuevaComisionRetornos;
      return updated;
    });
    return { ...store, viajes, empresasActivas };
  });
};

/** SUPERADMIN: Aprobar empresa pendiente */
export const aprobarEmpresa = (empresaId, comision = 20) => {
  return updateStore(store => {
    const empresa = store.empresasPendientes.find(e => e.id === empresaId);
    if (!empresa) return store;

    const empresaAprobada = {
      ...empresa,
      unidades: 0,
      choferes: 0,
      viajesActivos: 0,
      viajesCompletados: 0,
      comisionGenerada: 0,
      comisionPersonalizada: comision,
      calificacion: 0,
      fechaAprobacion: new Date().toISOString().split('T')[0],
      status: 'activa',
      documentosEmpresa: empresa.documentosEmpresa || DOCUMENTOS_REQUERIDOS.map(d => ({ id: d.id, nombre: d.nombre, status: 'verificado' })),
      unidadesDetalle: []
    };

    const empresasPendientes = store.empresasPendientes.filter(e => e.id !== empresaId);
    const empresasActivas = [...store.empresasActivas, empresaAprobada];

    // Activar cuenta del transportista si fue registrada desde el portal
    const usuarios = store.usuarios.map(u =>
      u.empresaId === empresaId && u.rol === 'transportista' && u.status === 'pendiente'
        ? { ...u, status: 'activo' }
        : u
    );

    // Notificar al transportista que fue aprobado
    const usuarioTransportista = store.usuarios.find(u => u.empresaId === empresaId && u.rol === 'transportista');
    let notificaciones = store.notificaciones || [];
    if (usuarioTransportista) {
      notificaciones = _agregarNotif({ ...store, notificaciones }, {
        destinatarioId: usuarioTransportista.id,
        tipo: 'empresa_aprobada',
        titulo: '🎉 ¡Tu empresa fue aprobada!',
        mensaje: `Tu empresa "${empresa.nombre}" fue revisada y aprobada. Ahora tienes acceso completo a la plataforma para cotizar y gestionar viajes.`,
        datos: { empresaId }
      });
    }

    return { ...store, empresasPendientes, empresasActivas, usuarios, notificaciones };
  });
};

/** SUPERADMIN: Rechazar empresa pendiente */
export const rechazarEmpresa = (empresaId) => {
  return updateStore(store => {
    const empresa = store.empresasPendientes.find(e => e.id === empresaId);
    const usuarioTransportista = store.usuarios.find(u => u.empresaId === empresaId && u.rol === 'transportista');
    let notificaciones = store.notificaciones || [];
    if (usuarioTransportista && empresa) {
      notificaciones = _agregarNotif(store, {
        destinatarioId: usuarioTransportista.id,
        tipo: 'empresa_rechazada',
        titulo: '❌ Solicitud de empresa no aprobada',
        mensaje: `La documentación de "${empresa.nombre}" no cumplió los requisitos. Contacta a soporte@choyero.app para más información.`,
        datos: { empresaId }
      });
    }
    return {
      ...store,
      empresasPendientes: store.empresasPendientes.filter(e => e.id !== empresaId),
      notificaciones
    };
  });
};

/** Calificar un servicio completado (cliente califica transportista o viceversa) */
export const calificarServicio = (viajeId, autorId, autorRol, destinatarioId, destinatarioRol, estrellas, comentario, choferUserId = null) => {
  return updateStore(store => {
    const ya = (store.calificaciones || []).find(c => c.viajeId === viajeId && c.autorRol === autorRol);
    if (ya) return store; // No permitir doble calificación

    const nueva = {
      id: `CAL-${Date.now()}`,
      viajeId, autorId, autorRol, destinatarioId, destinatarioRol,
      estrellas, comentario: comentario || '',
      fecha: new Date().toISOString()
    };
    const calificaciones = [...(store.calificaciones || []), nueva];

    // Actualizar promedio de calificación de la empresa (transportista)
    const viaje = store.viajes.find(v => v.id === viajeId);
    let empresasActivas = store.empresasActivas;
    if (viaje?.empresaId) {
      empresasActivas = store.empresasActivas.map(e => {
        if (e.id !== viaje.empresaId) return e;
        const califs = calificaciones.filter(c => c.destinatarioId === e.id || (c.destinatarioRol === 'transportista' && store.viajes.find(v => v.id === c.viajeId)?.empresaId === e.id));
        const promedio = califs.length ? Math.round((califs.reduce((s, c) => s + c.estrellas, 0) / califs.length) * 10) / 10 : e.calificacion;
        return { ...e, calificacion: promedio };
      });
    }

    // Propagar la misma calificación al chofer en plantillaChoferes y store.usuarios
    let plantillaChoferes = store.plantillaChoferes || [];
    let usuarios = store.usuarios || [];
    if (choferUserId) {
      const usuarioChofer = usuarios.find(u => u.id === choferUserId);
      plantillaChoferes = plantillaChoferes.map(c => {
        const esEsteChofer = usuarioChofer
          ? c.email === usuarioChofer.email
          : c.id === choferUserId || choferUserId === `chofer-${c.id}`;
        if (!esEsteChofer) return c;
        const prevCalif = c.calificacion || 0;
        const prevCount = c.totalCalificaciones || 0;
        const nuevoPromedio = prevCount === 0
          ? estrellas
          : Math.round(((prevCalif * prevCount + estrellas) / (prevCount + 1)) * 10) / 10;
        return { ...c, calificacion: nuevoPromedio, totalCalificaciones: prevCount + 1 };
      });
      // También actualizar store.usuarios para que choferInfo.calificacion lo refleje
      // El choferUserId puede ser el ID de usuario (U-002) o un ID de plantilla (chofer-CH-001)
      const resolvedChoferUser = usuarioChofer || usuarios.find(u =>
        u.email === (store.plantillaChoferes || []).find(c =>
          c.id === choferUserId || `chofer-${c.id}` === choferUserId
        )?.email
      );
      if (resolvedChoferUser) {
        usuarios = usuarios.map(u => {
          if (u.id !== resolvedChoferUser.id) return u;
          const prevCalif = u.calificacion || 0;
          const prevCount = u.totalCalificaciones || 0;
          const nuevoPromedio = prevCount === 0
            ? estrellas
            : Math.round(((prevCalif * prevCount + estrellas) / (prevCount + 1)) * 10) / 10;
          return { ...u, calificacion: nuevoPromedio, totalCalificaciones: prevCount + 1 };
        });
      }
    }

    // Actualizar calificacionRecibida en historialEntregas del chofer
    const historialEntregas = (store.historialEntregas || []).map(h =>
      h.viajeId === viajeId ? { ...h, calificacionRecibida: estrellas } : h
    );

    return { ...store, calificaciones, empresasActivas, plantillaChoferes, historialEntregas, usuarios };
  });
};

/** TRANSPORTISTA: Subir documento (guarda el archivo en base64 para que el admin pueda verlo) */
export const subirDocumentoEmpresa = (empresaId, docId, fileDataUrl, fileName) => {
  return updateStore(store => {
    const actualizarDoc = (docsList) => {
      // Siempre partir de los 5 documentos base para no perder los no subidos aún
      const base = DOCUMENTOS_REQUERIDOS.map(d => {
        const existente = (docsList || []).find(x => x.id === d.id);
        return existente || { id: d.id, nombre: d.nombre, status: 'pendiente' };
      });
      return base.map(d =>
        d.id === docId ? { ...d, status: 'subido', fechaSubida: new Date().toISOString(), fileDataUrl, fileName } : d
      );
    };
    const marcarDoc = (lista) => lista.map(e => {
      if (e.id !== empresaId) return e;
      return { ...e, documentosEmpresa: actualizarDoc(e.documentosEmpresa) };
    });

    // Actualizar miEmpresa si corresponde
    const miEmpresaActualizada = store.miEmpresa?.id === empresaId
      ? { ...store.miEmpresa, documentosEmpresa: actualizarDoc(store.miEmpresa.documentosEmpresa) }
      : store.miEmpresa;

    const enActivas = store.empresasActivas.some(e => e.id === empresaId);
    return {
      ...store,
      miEmpresa: miEmpresaActualizada,
      empresasActivas: enActivas ? marcarDoc(store.empresasActivas) : store.empresasActivas,
      empresasPendientes: !enActivas ? marcarDoc(store.empresasPendientes) : store.empresasPendientes,
    };
  });
};

export const actualizarFileUrlDocumento = (empresaId, docId, fileUrl) => {
  return updateStore(store => {
    const actualizarDoc = (docsList) => (docsList || []).map(d =>
      d.id === docId ? { ...d, fileUrl, fileDataUrl: undefined } : d
    );
    const actualizar = (lista) => lista.map(e => {
      if (e.id !== empresaId) return e;
      return { ...e, documentosEmpresa: actualizarDoc(e.documentosEmpresa) };
    });
    const miEmpresaActualizada = store.miEmpresa?.id === empresaId
      ? { ...store.miEmpresa, documentosEmpresa: actualizarDoc(store.miEmpresa.documentosEmpresa) }
      : store.miEmpresa;
    return {
      ...store,
      miEmpresa: miEmpresaActualizada,
      empresasPendientes: actualizar(store.empresasPendientes),
      empresasActivas: actualizar(store.empresasActivas),
    };
  });
};

/** SUPERADMIN: Cambiar status de un documento individual */
export const actualizarStatusDocumento = (empresaId, docId, status) => {
  return updateStore(store => {
    const actualizar = (lista) => lista.map(e => {
      if (e.id !== empresaId) return e;
      const documentosEmpresa = (e.documentosEmpresa || []).map(d =>
        d.id === docId ? { ...d, status } : d
      );
      return { ...e, documentosEmpresa };
    });
    return {
      ...store,
      empresasPendientes: actualizar(store.empresasPendientes),
      empresasActivas: actualizar(store.empresasActivas),
    };
  });
};

/** SUPERADMIN: Validar documentos y activar empresa completamente */
export const validarDocumentosEmpresa = (empresaId) => {
  return updateStore(store => {
    const empresa = store.empresasActivas.find(e => e.id === empresaId);
    if (!empresa) return store;

    const empresasActivas = store.empresasActivas.map(e => {
      if (e.id !== empresaId) return e;
      const documentosEmpresa = (e.documentosEmpresa || []).map(d => ({ ...d, status: 'verificado' }));
      return { ...e, status: 'activa', documentosEmpresa };
    });

    const usuarioTransportista = store.usuarios.find(u => u.empresaId === empresaId && u.rol === 'transportista');
    let notificaciones = store.notificaciones || [];
    if (usuarioTransportista) {
      notificaciones = _agregarNotif({ ...store, notificaciones }, {
        destinatarioId: usuarioTransportista.id,
        tipo: 'docs_validados',
        titulo: '✅ ¡Documentación verificada!',
        mensaje: `Tu documentación fue revisada y aprobada. La empresa "${empresa.nombre}" ahora tiene acceso completo a la plataforma.`,
        datos: { empresaId }
      });
    }
    return { ...store, empresasActivas, notificaciones };
  });
};

/** SUPERADMIN: Suspender/reactivar empresa activa */
/** SUPERADMIN: Editar rol, permisos y/o contraseña de un administrador */
export const actualizarAdministrador = (userId, cambios) => {
  return updateStore(store => ({
    ...store,
    usuarios: store.usuarios.map(u =>
      u.id === userId ? { ...u, ...cambios } : u
    )
  }));
};

/** SUPERADMIN: Crear un nuevo administrador del panel */
export const crearAdministrador = ({ nombre, email, password, rol, permisos }) => {
  return updateStore(store => {
    if (store.usuarios.find(u => u.email === email)) return store;
    const nuevoAdmin = {
      id: `U-A-${Date.now()}`,
      nombre,
      email,
      password,
      rol,
      permisos,
      status: 'activo',
      avatar: nombre.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase(),
      fechaCreacion: new Date().toISOString().split('T')[0]
    };
    return { ...store, usuarios: [...store.usuarios, nuevoAdmin] };
  });
};

/** SUPERADMIN: Activar / desactivar un administrador */
export const toggleStatusAdministrador = (userId) => {
  return updateStore(store => ({
    ...store,
    usuarios: store.usuarios.map(u =>
      u.id === userId ? { ...u, activo: !u.activo } : u
    )
  }));
};

/** SUPERADMIN: Eliminar un administrador */
/** SUPERADMIN: Guardar insignias de un cliente */
export const actualizarInsigniasCliente = (clienteId, insignias) => {
  return updateStore(store => ({
    ...store,
    // Clientes nuevos viven en store.usuarios (rol=cliente)
    usuarios: store.usuarios.map(u =>
      u.id === clienteId && u.rol === 'cliente' ? { ...u, insigniasCliente: insignias } : u
    ),
    // Compatibilidad con clientes legacy en store.clientes
    clientes: (store.clientes || []).map(c =>
      c.id === clienteId ? { ...c, insigniasCliente: insignias } : c
    )
  }));
};

export const eliminarAdministrador = (userId) => {
  return updateStore(store => ({
    ...store,
    usuarios: store.usuarios.filter(u => u.id !== userId)
  }));
};

/** TRANSPORTISTA: Actualizar datos del perfil de empresa */
export const actualizarPerfilEmpresa = (empresaId, cambios) => {
  return updateStore(store => ({
    ...store,
    empresasActivas: store.empresasActivas.map(e =>
      e.id === empresaId ? { ...e, ...cambios } : e
    )
  }));
};

/** CLIENTE: Actualizar datos del perfil */
export const actualizarPerfilCliente = (userId, cambios) => {
  return updateStore(store => ({
    ...store,
    usuarios: store.usuarios.map(u =>
      u.id === userId ? { ...u, ...cambios } : u
    )
  }));
};

/** CHAT: Enviar mensaje en un viaje activo */
export const enviarMensaje = (viajeId, emisorId, emisorNombre, emisorRol, texto, destinatarioRol) => {
  return updateStore(store => ({
    ...store,
    mensajes: [...(store.mensajes || []), {
      id: `MSG-${Date.now()}`,
      viajeId,
      emisorId,
      emisorNombre,
      emisorRol,
      destinatarioRol: destinatarioRol || null,
      texto,
      fecha: new Date().toISOString()
    }]
  }));
};

/** CHOFER: Guardar ubicación GPS actual para un viaje */
export const actualizarUbicacionChofer = (viajeId, lat, lng) => {
  return updateStore(store => ({
    ...store,
    ubicacionesChoferes: {
      ...(store.ubicacionesChoferes || {}),
      [viajeId]: { lat, lng, timestamp: new Date().toISOString() }
    }
  }));
};

/** SUPERADMIN: Activar/desactivar difusión global de solicitudes a todos los transportistas */
export const toggleDifusionGlobal = () => {
  return updateStore(store => {
    const yaActiva = !!store.configPlataforma?.difusionGlobal;
    const nuevoEstado = !yaActiva;

    let notificaciones = store.notificaciones || [];

    // Al ACTIVAR: notificar a todos los transportistas de las solicitudes abiertas
    // que aún no recibieron notificación de esa solicitud
    if (nuevoEstado) {
      const solicitudesAbiertas = (store.solicitudes || []).filter(s => s.status === 'cotizando' && s.aceptaCotizaciones);
      const usuariosTransp = (store.usuarios || []).filter(u => u.rol === 'transportista');
      const todasLasEmpresas = store.empresasActivas || [];

      solicitudesAbiertas.forEach(sol => {
        todasLasEmpresas.forEach(empresa => {
          const u = usuariosTransp.find(u => u.empresaId === empresa.id);
          if (!u) return;
          // Evitar duplicado: ya tiene notificación de esta solicitud
          const yaTiene = notificaciones.some(
            n => n.destinatarioId === u.id && n.tipo === 'nueva_solicitud' && n.datos?.solicitudId === sol.id
          );
          if (yaTiene) return;
          notificaciones = _agregarNotif({ ...store, notificaciones }, {
            destinatarioId: u.id,
            tipo: 'nueva_solicitud',
            titulo: '🌐 Solicitud disponible (difusión global)',
            mensaje: `Flete de ${sol.origen || ''} a ${sol.destino || ''}`,
            datos: { solicitudId: sol.id }
          });
        });
      });
    }

    return {
      ...store,
      configPlataforma: { ...store.configPlataforma, difusionGlobal: nuevoEstado },
      notificaciones
    };
  });
};

// ============================================================
// RETORNOS VACÍOS
// ============================================================

/** TRANSPORTISTA: Publica un retorno vacío. Notifica a clientes en las ciudades de la ruta. */
export const publicarRetornoVacio = (transportistaId, empresaId, datos) => {
  return updateStore(store => {
    const empresa = (store.empresasActivas || []).find(e => e.id === empresaId);
    const transportista = (store.usuarios || []).find(u => u.id === transportistaId);
    const ciudadesEnRuta = calcCiudadesEnRuta(datos.origenActual, datos.destino);
    const todasLasCiudades = [datos.origenActual, ...ciudadesEnRuta, datos.destino];
    const id = `RV-${String((store.retornosVacios || []).length + 1).padStart(3, '0')}`;
    const fechaPublicacion = new Date().toISOString();
    const fechaExpiracion = datos.expiresAt
      ? new Date(datos.expiresAt).toISOString()
      : new Date(Date.now() + 12 * 60 * 60 * 1000).toISOString();
    const nuevo = {
      id,
      transportistaId,
      empresaId,
      empresaNombre: empresa?.nombre || 'Transportista',
      transportistaNombre: transportista?.nombre || 'Transportista',
      origenActual: datos.origenActual,
      destino: datos.destino,
      ciudadesEnRuta,
      tipoUnidad: datos.tipoUnidad || '',
      capacidadDisponible: datos.capacidadDisponible || '',
      descripcion: datos.descripcion || '',
      precioBase: Number(datos.precioBase) || 0,
      precioMinimo: Number(datos.precioMinimo) || 0,
      expiresAt: fechaExpiracion,
      descuentoProgresivo: true,
      status: 'disponible',
      fechaPublicacion,
      fechaExpiracion,
      ofertas: [],
      viajeOrigenId: datos.viajeOrigenId || null,
    };
    // Notificar a clientes cuya ciudad esté en la ruta.
    // Se busca el nombre de cada ciudad de la ruta como substring en la dirección
    // completa del cliente (insensible a acentos/mayúsculas).
    const _normFull = (str) => (str || '').toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    let notificaciones = store.notificaciones || [];
    const clientesEnRuta = (store.usuarios || []).filter(u => {
      if (u.rol !== 'cliente') return false;
      const dirNorm = _normFull(u.direccion || '');
      // Si el cliente no tiene dirección registrada, notificar igual (sin filtro)
      if (!dirNorm) return true;
      return todasLasCiudades.some(c => dirNorm.includes(_normFull(c.split(',')[0])));
    });
    clientesEnRuta.forEach(cliente => {
      notificaciones = _agregarNotif({ ...store, notificaciones }, {
        destinatarioId: cliente.id,
        tipo: 'retorno_disponible',
        titulo: '🔄 Flete de retorno disponible en tu zona',
        mensaje: `${nuevo.empresaNombre}: ${datos.origenActual} → ${datos.destino} · ${datos.tipoUnidad} · $${Number(datos.precioBase).toLocaleString()}`,
        datos: { retornoId: id }
      });
    });
    return {
      ...store,
      retornosVacios: [...(store.retornosVacios || []), nuevo],
      notificaciones
    };
  });
};

/** CLIENTE: Hace una oferta (o contraoferta) en un retorno vacío.
 *  Si monto >= precioMinimo → auto-acepta. */
export const hacerOfertaRetorno = (retornoId, clienteId, clienteNombre, ciudadCliente, monto, mensaje = '', carga = {}) => {
  return updateStore(store => {
    const idx = (store.retornosVacios || []).findIndex(r => r.id === retornoId);
    if (idx === -1) return store;
    const retorno = store.retornosVacios[idx];
    if (!['disponible', 'en_negociacion'].includes(retorno.status)) return store;

    const ofertaId = `OFR-${retornoId}-${Date.now()}`;
    const autoAceptar = monto >= retorno.precioMinimo;
    const nuevaOferta = {
      id: ofertaId,
      clienteId,
      clienteNombre,
      ciudadCliente,
      monto: Number(monto),
      mensaje,
      peso: carga.peso || '',
      volumen: carga.volumen || '',
      fotos: carga.fotos || [],
      destinoEntrega: carga.destinoEntrega || '',
      origenCoords: carga.origenCoords || null,
      destinoCoords: carga.destinoCoords || null,
      fecha: new Date().toISOString(),
      status: autoAceptar ? 'aceptada' : 'pendiente',
      rondas: 1,
      historial: [{ accion: 'oferta_cliente', monto: Number(monto), mensaje, fecha: new Date().toISOString() }],
    };
    const retornoActualizado = {
      ...retorno,
      ofertas: [...retorno.ofertas, nuevaOferta],
      status: autoAceptar ? 'confirmado' : 'en_negociacion',
    };
    let notificaciones = store.notificaciones || [];
    if (autoAceptar) {
      // Notificar transportista: oferta aceptada automáticamente
      notificaciones = _agregarNotif({ ...store, notificaciones }, {
        destinatarioId: retorno.transportistaId,
        tipo: 'retorno_confirmado',
        titulo: '✅ ¡Retorno confirmado automáticamente!',
        mensaje: `${clienteNombre} ofreció $${Number(monto).toLocaleString()} (≥ tu precio mínimo). Ruta: ${retorno.origenActual} → ${retorno.destino}`,
        datos: { retornoId, ofertaId }
      });
      notificaciones = _agregarNotif({ ...store, notificaciones }, {
        destinatarioId: clienteId,
        tipo: 'retorno_aceptado',
        titulo: '🎉 Tu oferta fue aceptada',
        mensaje: `Flete ${retorno.origenActual} → ${retorno.destino} confirmado por $${Number(monto).toLocaleString()}`,
        datos: { retornoId, ofertaId }
      });
    } else {
      // Notificar transportista de nueva oferta
      notificaciones = _agregarNotif({ ...store, notificaciones }, {
        destinatarioId: retorno.transportistaId,
        tipo: 'nueva_oferta_retorno',
        titulo: '💬 Nueva oferta en tu retorno',
        mensaje: `${clienteNombre} ofrece $${Number(monto).toLocaleString()} — recoge en ${ciudadCliente}${carga.destinoEntrega ? ` → entrega en ${carga.destinoEntrega}` : ''}`,
        datos: { retornoId, ofertaId }
      });
    }
    const retornosVacios = store.retornosVacios.map((r, i) => i === idx ? retornoActualizado : r);
    return { ...store, retornosVacios, notificaciones };
  });
};

/** TRANSPORTISTA: Responde a una oferta (aceptar / rechazar / contraoferta). */
export const responderOfertaRetorno = (retornoId, ofertaId, accion, contrapropuesta = null) => {
  return updateStore(store => {
    const idx = (store.retornosVacios || []).findIndex(r => r.id === retornoId);
    if (idx === -1) return store;
    const retorno = store.retornosVacios[idx];
    const ofertaIdx = retorno.ofertas.findIndex(o => o.id === ofertaId);
    if (ofertaIdx === -1) return store;
    const oferta = retorno.ofertas[ofertaIdx];

    const entrada = { accion, monto: contrapropuesta?.monto || oferta.precio || oferta.monto, mensaje: contrapropuesta?.mensaje || '', fecha: new Date().toISOString() };
    let nuevaOferta = { ...oferta, historial: [...(oferta.historial || []), entrada], rondas: (oferta.rondas || 0) + 1 };
    let nuevoStatusRetorno = retorno.status;
    let notificaciones = store.notificaciones || [];

    if (accion === 'aceptar') {
      nuevaOferta = { ...nuevaOferta, status: 'aceptada' };
      // Mantener disponible para que el transportista pueda aceptar más clientes
      nuevoStatusRetorno = retorno.status === 'confirmado' ? 'confirmado' : 'disponible';
      notificaciones = _agregarNotif({ ...store, notificaciones }, {
        destinatarioId: oferta.clienteId,
        tipo: 'retorno_aceptado',
        titulo: '🎉 ¡Tu oferta fue aceptada!',
        mensaje: `Flete ${retorno.origenActual || retorno.origen} → ${retorno.destino} confirmado por $${(oferta.precio || oferta.monto || 0).toLocaleString()}`,
        datos: { retornoId, ofertaId }
      });
    } else if (accion === 'rechazar') {
      nuevaOferta = { ...nuevaOferta, status: 'rechazada' };
      const hayOtrasPendientes = retorno.ofertas.some((o, i) => i !== ofertaIdx && o.status === 'pendiente');
      nuevoStatusRetorno = hayOtrasPendientes ? 'en_negociacion' : 'disponible';
      notificaciones = _agregarNotif({ ...store, notificaciones }, {
        destinatarioId: oferta.clienteId,
        tipo: 'retorno_rechazado',
        titulo: '❌ Tu oferta fue rechazada',
        mensaje: `El transportista no aceptó tu propuesta para ${retorno.origenActual} → ${retorno.destino}`,
        datos: { retornoId, ofertaId }
      });
    } else if (accion === 'contraoferta' && contrapropuesta) {
      nuevaOferta = { ...nuevaOferta, status: 'contraoferta', montoContra: contrapropuesta.monto };
      notificaciones = _agregarNotif({ ...store, notificaciones }, {
        destinatarioId: oferta.clienteId,
        tipo: 'retorno_contraoferta',
        titulo: '🔄 Contraoferta del transportista',
        mensaje: `Propone $${contrapropuesta.monto.toLocaleString()} para ${retorno.origenActual} → ${retorno.destino}${contrapropuesta.mensaje ? ': ' + contrapropuesta.mensaje : ''}`,
        datos: { retornoId, ofertaId }
      });
    }
    const ofertas = retorno.ofertas.map((o, i) => {
      if (i === ofertaIdx) return nuevaOferta;
      return o;
    });
    const retornoActualizado = { ...retorno, ofertas, status: nuevoStatusRetorno };
    const retornosVacios = store.retornosVacios.map((r, i) => i === idx ? retornoActualizado : r);
    return { ...store, retornosVacios, notificaciones };
  });
};

/** TRANSPORTISTA: Cierra manualmente el retorno para nuevas ofertas.
 *  Marca las ofertas pendientes/contraoferta restantes como perdidas y notifica a esos clientes. */
export const cerrarRetornoManual = (retornoId) => {
  return updateStore(store => {
    const idx = (store.retornosVacios || []).findIndex(r => r.id === retornoId);
    if (idx === -1) return store;
    const retorno = store.retornosVacios[idx];
    let notificaciones = store.notificaciones || [];
    const ofertas = (retorno.ofertas || []).map(o => {
      if (['pendiente', 'contraoferta'].includes(o.status)) {
        notificaciones = _agregarNotif({ ...store, notificaciones }, {
          destinatarioId: o.clienteId,
          tipo: 'retorno_no_ganado',
          titulo: '😔 El transportista eligió a otro cliente',
          mensaje: `Tu oferta para el retorno ${retorno.origenActual} → ${retorno.destino} no fue seleccionada`,
          datos: { retornoId }
        });
        return { ...o, status: 'perdida' };
      }
      return o;
    });
    const retornoActualizado = { ...retorno, ofertas, status: 'confirmado' };
    const retornosVacios = store.retornosVacios.map((r, i) => i === idx ? retornoActualizado : r);
    return { ...store, retornosVacios, notificaciones };
  });
};

/** TRANSPORTISTA: Notifica a un chofer sobre un retorno confirmado. */
export const confirmarPagoRetorno = (retornoId, ofertaId) => {
  return updateStore(store => {
    const retorno = (store.retornosVacios || []).find(r => r.id === retornoId);
    if (!retorno) return store;
    const retornosVacios = (store.retornosVacios || []).map(r => {
      if (r.id !== retornoId) return r;
      return { ...r, ofertas: (r.ofertas || []).map(o => o.id === ofertaId ? { ...o, pagado: true, fechaPago: new Date().toISOString() } : o) };
    });
    const oferta = (retorno.ofertas || []).find(o => o.id === ofertaId);
    const notificaciones = _agregarNotif({ ...store, retornosVacios }, {
      destinatarioId: retorno.transportistaId,
      tipo: 'retorno_pagado',
      titulo: '💳 Pago recibido — retorno confirmado',
      mensaje: `${oferta?.clienteNombre || 'El cliente'} completó el pago de $${(oferta?.monto || 0).toLocaleString()}. Ya puedes asignar el chofer.`,
      datos: { retornoId, ofertaId }
    });
    return { ...store, retornosVacios, notificaciones };
  });
};

export const confirmarDireccionesRetorno = (retornoId, ofertaId, origenDir, destinoDir) => {
  return updateStore(store => {
    const retorno = (store.retornosVacios || []).find(r => r.id === retornoId);
    if (!retorno) return store;
    const retornosVacios = (store.retornosVacios || []).map(r => {
      if (r.id !== retornoId) return r;
      return {
        ...r,
        ofertas: (r.ofertas || []).map(o =>
          o.id === ofertaId ? { ...o, origenDir, destinoDir } : o
        )
      };
    });
    // Notificar al transportista con las direcciones exactas
    const oferta = (retorno.ofertas || []).find(o => o.id === ofertaId);
    const notificaciones = _agregarNotif({ ...store, retornosVacios }, {
      destinatarioId: retorno.transportistaId,
      tipo: 'retorno_direcciones',
      titulo: '📍 Cliente confirmó las direcciones del servicio',
      mensaje: `Recogida: ${origenDir} → Entrega: ${destinoDir}${oferta ? ` (${oferta.ciudadCliente} → ${oferta.destinoEntrega || retorno.destino})` : ''}`,
      datos: { retornoId, ofertaId }
    });
    return { ...store, retornosVacios, notificaciones };
  });
};

export const notificarChoferRetorno = (retornoId, choferId) => {
  return updateStore(store => {
    const retorno = (store.retornosVacios || []).find(r => r.id === retornoId);
    if (!retorno) return store;
    const ofertaAceptada = (retorno.ofertas || []).find(o => o.status === 'aceptada' && o.pagado);
    const dirOrigen = ofertaAceptada?.origenCoords?.direccion || ofertaAceptada?.ciudadCliente || retorno.origenActual;
    const dirDestino = ofertaAceptada?.destinoCoords?.direccion || ofertaAceptada?.destinoEntrega || retorno.destino;

    // Buscar datos del chofer
    const choferUsuario = (store.usuarios || []).find(u => u.id === choferId);

    // Crear orden de trabajo en ordenesChofer
    const ordenId = `OT-R-${String(Date.now()).slice(-6)}`;
    const nuevaOrden = {
      id: ordenId,
      choferId,
      choferEmail: choferUsuario?.email || '',
      retornoId,
      empresaId: retorno.empresaId,
      cliente: ofertaAceptada?.clienteNombre || 'Cliente',
      contactoCliente: '',
      telefonoCliente: '',
      origen: ofertaAceptada?.ciudadCliente || retorno.origenActual,
      destino: ofertaAceptada?.destinoEntrega || retorno.destino,
      origenDir: dirOrigen,
      destinoDir: dirDestino,
      origenCoords: ofertaAceptada?.origenCoords || null,
      destinoCoords: ofertaAceptada?.destinoCoords || null,
      carga: `Retorno vacío${ofertaAceptada?.peso ? ` · ${ofertaAceptada.peso} ton` : ''}`,
      peso: ofertaAceptada?.peso ? `${ofertaAceptada.peso} tons` : 'Ver detalles',
      tipoUnidad: retorno.tipoUnidad || '',
      unidad: retorno.tipoUnidad || '',
      fechaRecogida: new Date().toISOString().split('T')[0],
      horaRecogida: '08:00',
      distancia: 'Ver mapa',
      tiempoEstimado: 'Ver mapa',
      instrucciones: `Retorno vacío. Ciudades en ruta: ${(retorno.ciudadesEnRuta || []).join(', ') || 'N/A'}`,
      status: 'asignada',
      prioridad: 'normal',
      esRetorno: true,
      fechaCreacion: new Date().toISOString()
    };

    const notificaciones = _agregarNotif(store, {
      destinatarioId: choferId,
      tipo: 'retorno_asignado',
      titulo: '🔄 Nuevo servicio de retorno asignado',
      mensaje: `Nuevo flete asignado.\n📦 Recoger en: ${dirOrigen}\n📍 Entregar en: ${dirDestino}${ofertaAceptada?.peso ? `\n⚖️ Carga: ${ofertaAceptada.peso} ton` : ''}`,
      datos: { retornoId, ordenId }
    });

    // Marcar el retorno con el chofer asignado
    const retornosVacios = (store.retornosVacios || []).map(r =>
      r.id === retornoId ? { ...r, choferAsignado: choferId } : r
    );

    return {
      ...store,
      retornosVacios,
      ordenesChofer: [...store.ordenesChofer, nuevaOrden],
      notificaciones
    };
  });
};

/** CLIENTE: Confirma que recibió la entrega de un retorno. */
export const confirmarEntregaRetorno = (retornoId, ofertaId) => {
  return updateStore(store => {
    const retorno = (store.retornosVacios || []).find(r => r.id === retornoId);
    if (!retorno) return store;
    const retornosVacios = (store.retornosVacios || []).map(r => {
      if (r.id !== retornoId) return r;
      return {
        ...r,
        status: 'entrega_confirmada',
        fechaEntregaConfirmada: new Date().toISOString(),
        ofertas: (r.ofertas || []).map(o => o.id === ofertaId ? { ...o, entregaConfirmada: true, fechaEntregaConfirmada: new Date().toISOString() } : o)
      };
    });
    const oferta = (retorno.ofertas || []).find(o => o.id === ofertaId);
    const notificaciones = _agregarNotif({ ...store, retornosVacios }, {
      destinatarioId: retorno.transportistaId,
      tipo: 'retorno_entrega_confirmada',
      titulo: '✅ Cliente confirmó la entrega del retorno',
      mensaje: `${oferta?.clienteNombre || 'El cliente'} confirmó la recepción. Ruta: ${retorno.origenActual} → ${retorno.destino}.`,
      datos: { retornoId, ofertaId }
    });
    // Limpiar la orden del chofer ya que el retorno fue confirmado
    const ordenesChofer = (store.ordenesChofer || []).filter(o => o.retornoId !== retornoId);
    return { ...store, retornosVacios, notificaciones, ordenesChofer };
  });
};

/** TRANSPORTISTA: Cancela un retorno vacío propio. */
export const cancelarRetornoVacio = (retornoId) => {
  return updateStore(store => {
    const retornosVacios = (store.retornosVacios || []).map(r =>
      r.id === retornoId ? { ...r, status: 'cancelado' } : r
    );
    return { ...store, retornosVacios };
  });
};

/** CLIENTE: Acepta una contraoferta del transportista. */
export const aceptarContraofertaRetorno = (retornoId, ofertaId) => {
  return updateStore(store => {
    const idx = (store.retornosVacios || []).findIndex(r => r.id === retornoId);
    if (idx === -1) return store;
    const retorno = store.retornosVacios[idx];
    const ofertaIdx = retorno.ofertas.findIndex(o => o.id === ofertaId);
    if (ofertaIdx === -1) return store;
    const oferta = retorno.ofertas[ofertaIdx];
    const montoFinal = oferta.montoContra || oferta.contrapropuesta || oferta.monto;
    const nuevaOferta = {
      ...oferta,
      status: 'aceptada',
      monto: montoFinal,
      historial: [...(oferta.historial || []), { accion: 'acepta_contraoferta_cliente', monto: montoFinal, fecha: new Date().toISOString() }]
    };
    let notificaciones = store.notificaciones || [];
    notificaciones = _agregarNotif({ ...store, notificaciones }, {
      destinatarioId: retorno.transportistaId,
      tipo: 'retorno_confirmado',
      titulo: '✅ ¡Retorno confirmado!',
      mensaje: `${oferta.clienteNombre} aceptó tu contraoferta de $${montoFinal.toLocaleString()}`,
      datos: { retornoId, ofertaId }
    });
    const ofertas = retorno.ofertas.map((o, i) => i === ofertaIdx ? nuevaOferta : o);
    const retornoActualizado = { ...retorno, ofertas, status: 'confirmado' };
    const retornosVacios = store.retornosVacios.map((r, i) => i === idx ? retornoActualizado : r);
    return { ...store, retornosVacios, notificaciones };
  });
};

/** CLIENTE: Rechaza la contraoferta del transportista y notifica al transportista. */
export const rechazarContraofertaCliente = (retornoId, ofertaId) => {
  return updateStore(store => {
    const idx = (store.retornosVacios || []).findIndex(r => r.id === retornoId);
    if (idx === -1) return store;
    const retorno = store.retornosVacios[idx];
    const ofertaIdx = retorno.ofertas.findIndex(o => o.id === ofertaId);
    if (ofertaIdx === -1) return store;
    const oferta = retorno.ofertas[ofertaIdx];
    const nuevaOferta = {
      ...oferta,
      status: 'rechazada',
      historial: [...(oferta.historial || []), { accion: 'rechaza_contraoferta_cliente', monto: oferta.montoContra || oferta.contrapropuesta || oferta.monto, fecha: new Date().toISOString() }]
    };
    let notificaciones = store.notificaciones || [];
    notificaciones = _agregarNotif({ ...store, notificaciones }, {
      destinatarioId: retorno.transportistaId,
      tipo: 'retorno_rechazado',
      titulo: '❌ Contraoferta rechazada',
      mensaje: `${oferta.clienteNombre} rechazó tu contraoferta de $${(oferta.montoContra || oferta.monto).toLocaleString()} para ${retorno.origenActual} → ${retorno.destino}`,
      datos: { retornoId, ofertaId }
    });
    const hayOtrasPendientes = retorno.ofertas.some((o, i) => i !== ofertaIdx && ['pendiente', 'contraoferta'].includes(o.status));
    const nuevoStatus = hayOtrasPendientes ? 'en_negociacion' : 'disponible';
    const ofertas = retorno.ofertas.map((o, i) => i === ofertaIdx ? nuevaOferta : o);
    const retornoActualizado = { ...retorno, ofertas, status: nuevoStatus };
    const retornosVacios = store.retornosVacios.map((r, i) => i === idx ? retornoActualizado : r);
    return { ...store, retornosVacios, notificaciones };
  });
};

/** CLIENTE: Actualiza las coordenadas GPS de una oferta existente. */
export const actualizarCoordsOferta = (retornoId, ofertaId, origenCoords, destinoCoords) => {
  return updateStore(store => {
    const retornosVacios = (store.retornosVacios || []).map(r => {
      if (r.id !== retornoId) return r;
      const ofertas = r.ofertas.map(o =>
        o.id === ofertaId ? { ...o, origenCoords: origenCoords || o.origenCoords, destinoCoords: destinoCoords || o.destinoCoords } : o
      );
      return { ...r, ofertas };
    });
    return { ...store, retornosVacios };
  });
};

// ============================================================
// FUNCIONES DE INTERVENCIÓN ADMIN
// ============================================================

const _logAdminEntry = (accion, adminNombre, detalle) => ({
  accion, autor: adminNombre || 'Admin', fecha: new Date().toISOString(), detalle: detalle || ''
});

/** ADMIN: Cancelar una solicitud de flete */
export const adminCancelarSolicitud = (solicitudId, motivo, adminNombre) => {
  return updateStore(store => {
    const entrada = _logAdminEntry('cancelar_solicitud', adminNombre, motivo);
    const solicitudes = (store.solicitudes || []).map(s =>
      s.id === solicitudId
        ? { ...s, status: 'cancelada', motivoCancelacionAdmin: motivo, canceladaPorAdmin: true, fechaCancelacion: new Date().toISOString(), logAdmin: [...(s.logAdmin || []), entrada] }
        : s
    );
    const sol = store.solicitudes.find(s => s.id === solicitudId);
    let notificaciones = store.notificaciones || [];
    if (sol) {
      notificaciones = _agregarNotif({ ...store, solicitudes, notificaciones }, {
        destinatarioId: sol.clienteId,
        tipo: 'solicitud_cancelada_admin',
        titulo: 'Solicitud cancelada por administración',
        mensaje: `Tu solicitud ${solicitudId} fue cancelada. Motivo: ${motivo}`,
        datos: { solicitudId }
      });
    }
    return { ...store, solicitudes, notificaciones };
  });
};

/** ADMIN: Cancelar un viaje activo */
export const adminCancelarViaje = (viajeId, motivo, adminNombre) => {
  return updateStore(store => {
    const entrada = _logAdminEntry('cancelar_viaje', adminNombre, motivo);
    const viajes = (store.viajes || []).map(v =>
      v.id === viajeId
        ? { ...v, status: 'cancelado_admin', motivoCancelacionAdmin: motivo, canceladoPorAdmin: true, fechaCancelacion: new Date().toISOString(), logAdmin: [...(v.logAdmin || []), entrada] }
        : v
    );
    const viaje = store.viajes.find(v => v.id === viajeId);
    let notificaciones = store.notificaciones || [];
    if (viaje) {
      notificaciones = _agregarNotif({ ...store, viajes, notificaciones }, {
        destinatarioId: viaje.clienteId,
        tipo: 'viaje_cancelado_admin',
        titulo: 'Tu viaje fue cancelado por administración',
        mensaje: `El administrador canceló el viaje. Motivo: ${motivo}`,
        datos: { viajeId }
      });
      notificaciones = _agregarNotif({ ...store, viajes, notificaciones }, {
        destinatarioId: viaje.transportistaId,
        tipo: 'viaje_cancelado_admin',
        titulo: 'Un viaje fue cancelado por administración',
        mensaje: `El viaje ${viajeId} fue cancelado. Motivo: ${motivo}`,
        datos: { viajeId }
      });
    }
    return { ...store, viajes, notificaciones };
  });
};

/** ADMIN: Marcar un viaje en disputa */
export const adminMarcarDisputa = (viajeId, motivo, adminNombre) => {
  return updateStore(store => {
    const entrada = _logAdminEntry('abrir_disputa', adminNombre, motivo);
    const viajes = (store.viajes || []).map(v =>
      v.id === viajeId
        ? { ...v, enDisputa: true, motivoDisputa: motivo, statusAnteriorDisputa: v.status, status: 'en_disputa', fechaDisputa: new Date().toISOString(), logAdmin: [...(v.logAdmin || []), entrada] }
        : v
    );
    const viaje = store.viajes.find(v => v.id === viajeId);
    let notificaciones = store.notificaciones || [];
    if (viaje) {
      notificaciones = _agregarNotif({ ...store, viajes, notificaciones }, {
        destinatarioId: viaje.clienteId,
        tipo: 'viaje_en_disputa',
        titulo: 'Tu viaje está en proceso de disputa',
        mensaje: `El administrador abrió una disputa. Te contactaremos para resolverla.`,
        datos: { viajeId }
      });
      notificaciones = _agregarNotif({ ...store, viajes, notificaciones }, {
        destinatarioId: viaje.transportistaId,
        tipo: 'viaje_en_disputa',
        titulo: 'Un viaje entró en proceso de disputa',
        mensaje: `El administrador abrió una disputa para el viaje ${viajeId}. Motivo: ${motivo}`,
        datos: { viajeId }
      });
    }
    return { ...store, viajes, notificaciones };
  });
};

/** ADMIN: Resolver una disputa activa */
export const adminResolverDisputa = (viajeId, resolucion, adminNombre) => {
  return updateStore(store => {
    const entrada = _logAdminEntry('resolver_disputa', adminNombre, resolucion);
    const viajes = (store.viajes || []).map(v =>
      v.id === viajeId
        ? { ...v, enDisputa: false, resolucionDisputa: resolucion, fechaResolucion: new Date().toISOString(), status: v.statusAnteriorDisputa || 'en_ruta', logAdmin: [...(v.logAdmin || []), entrada] }
        : v
    );
    const viaje = store.viajes.find(v => v.id === viajeId);
    let notificaciones = store.notificaciones || [];
    if (viaje) {
      [viaje.clienteId, viaje.transportistaId].filter(Boolean).forEach(uid => {
        notificaciones = _agregarNotif({ ...store, viajes, notificaciones }, {
          destinatarioId: uid,
          tipo: 'disputa_resuelta',
          titulo: 'Disputa resuelta por administración',
          mensaje: `La disputa del viaje ${viajeId} fue resuelta. Resolución: ${resolucion}`,
          datos: { viajeId }
        });
      });
    }
    return { ...store, viajes, notificaciones };
  });
};

/** ADMIN: Forzar completar un viaje atascado */
export const adminForzarCompletar = (viajeId, motivo, adminNombre) => {
  return updateStore(store => {
    const entrada = _logAdminEntry('forzar_completar', adminNombre, motivo);
    const viajes = (store.viajes || []).map(v =>
      v.id === viajeId
        ? { ...v, status: 'completada', completadoPorAdmin: true, motivoForzar: motivo, fechaCompletadoAdmin: new Date().toISOString(), logAdmin: [...(v.logAdmin || []), entrada] }
        : v
    );
    const viaje = store.viajes.find(v => v.id === viajeId);
    let notificaciones = store.notificaciones || [];
    if (viaje) {
      [viaje.clienteId, viaje.transportistaId].filter(Boolean).forEach(uid => {
        notificaciones = _agregarNotif({ ...store, viajes, notificaciones }, {
          destinatarioId: uid,
          tipo: 'viaje_completado_admin',
          titulo: 'Viaje marcado como completado',
          mensaje: `El administrador marcó el viaje ${viajeId} como completado. ${motivo}`,
          datos: { viajeId }
        });
      });
    }
    return { ...store, viajes, notificaciones };
  });
};

/** ADMIN: Agregar nota administrativa a una solicitud o viaje */
export const adminAgregarNota = (tipo, id, nota, adminNombre) => {
  const nota_entrada = { texto: nota, autor: adminNombre || 'Admin', fecha: new Date().toISOString() };
  const log_entrada = _logAdminEntry('agregar_nota', adminNombre, nota);
  return updateStore(store => {
    if (tipo === 'solicitud') {
      const solicitudes = (store.solicitudes || []).map(s =>
        s.id === id ? { ...s, notasAdmin: [...(s.notasAdmin || []), nota_entrada], logAdmin: [...(s.logAdmin || []), log_entrada] } : s
      );
      return { ...store, solicitudes };
    }
    if (tipo === 'viaje') {
      const viajes = (store.viajes || []).map(v =>
        v.id === id ? { ...v, notasAdmin: [...(v.notasAdmin || []), nota_entrada], logAdmin: [...(v.logAdmin || []), log_entrada] } : v
      );
      return { ...store, viajes };
    }
    return store;
  });
};

export const toggleStatusEmpresa = (empresaId, motivo = '') => {
  return updateStore(store => {
    const empresa = store.empresasActivas.find(e => e.id === empresaId);
    if (!empresa) return store;
    const nuevoStatus = empresa.status === 'activa' ? 'suspendida' : 'activa';
    const nuevaSancion = nuevoStatus === 'suspendida' ? {
      id: `SAN-${Date.now()}`,
      tipo: 'suspension',
      fecha: new Date().toISOString(),
      motivo: motivo || 'Sin motivo especificado',
      aplicadoPor: 'admin',
      status: 'activa'
    } : {
      id: `SAN-${Date.now()}`,
      tipo: 'reactivacion',
      fecha: new Date().toISOString(),
      motivo: motivo || 'Reactivación manual',
      aplicadoPor: 'admin',
      status: 'resuelta'
    };
    const empresasActivas = store.empresasActivas.map(e =>
      e.id === empresaId
        ? { ...e, status: nuevoStatus, historialSanciones: [...(e.historialSanciones || []), nuevaSancion] }
        : e
    );
    const usuarioTransportista = store.usuarios.find(u => u.empresaId === empresaId && u.rol === 'transportista');
    let notificaciones = store.notificaciones || [];
    if (usuarioTransportista) {
      notificaciones = _agregarNotif({ ...store, notificaciones }, {
        destinatarioId: usuarioTransportista.id,
        tipo: nuevoStatus === 'suspendida' ? 'empresa_suspendida' : 'empresa_reactivada',
        titulo: nuevoStatus === 'suspendida'
          ? '⚠️ Tu empresa ha sido suspendida'
          : '✅ Tu empresa ha sido reactivada',
        mensaje: nuevoStatus === 'suspendida'
          ? `La empresa "${empresa.nombre}" fue suspendida. Motivo: ${motivo || 'Sin especificar'}. Contacta a soporte@choyero.app para resolver la situación.`
          : `La empresa "${empresa.nombre}" fue reactivada. ${motivo ? `Nota: ${motivo}` : 'Ya puedes cotizar y operar normalmente.'}`,
        datos: { empresaId }
      });
    }
    return { ...store, empresasActivas, notificaciones };
  });
};

// ============================================================
// HOOKS DE NOTIFICACIÓN WHATSAPP
// Genera URL wa.me con mensaje pre-armado. Sin backend; el
// navegador abre WhatsApp Web/app. En producción, sustituir
// la URL por llamada al API de WhatsApp Business.
// ============================================================

/** Admin oculta el botón "Mejorar a PRO" para una empresa. */
export const ocultarOfertaPro = (empresaId) =>
  updateStore(store => ({
    ...store,
    proOfertaOculta: [...new Set([...(store.proOfertaOculta || []), empresaId])]
  }));

/** Admin vuelve a mostrar el botón "Mejorar a PRO" para una empresa. */
export const mostrarOfertaPro = (empresaId) =>
  updateStore(store => ({
    ...store,
    proOfertaOculta: (store.proOfertaOculta || []).filter(id => id !== empresaId)
  }));

/** Admin cierra una conversación con un transportista. El botón desaparece del lado del transportista. */
export const cerrarConversacionAdmin = (canal) =>
  updateStore(store => ({
    ...store,
    canalesAdminCerrados: [...new Set([...(store.canalesAdminCerrados || []), canal])]
  }));

/** Admin reabre una conversación (al enviar un nuevo mensaje se elimina del listado de cerrados). */
export const reabrirConversacionAdmin = (canal) =>
  updateStore(store => ({
    ...store,
    canalesAdminCerrados: (store.canalesAdminCerrados || []).filter(c => c !== canal)
  }));

/** Abre WhatsApp con un mensaje pre-armado. */
export const notifWhatsApp = (telefono, mensaje) => {
  if (!telefono) return;
  const tel = String(telefono).replace(/\D/g, '');
  if (!tel) return;
  const url = `https://wa.me/${tel}?text=${encodeURIComponent(mensaje)}`;
  window.open(url, '_blank', 'noopener,noreferrer');
};

/** Notifica al chofer que tiene una nueva orden asignada. */
export const notifWhatsAppNuevaOrden = (chofer, orden) => {
  const msg = `🚛 *Choyero - Nueva orden asignada*\n\nHola ${chofer.nombre}, tienes una nueva orden:\n\n📦 *Orden:* ${orden.id}\n🗺️ *Ruta:* ${orden.origen} → ${orden.destino}\n📅 *Fecha:* ${orden.fechaServicio || 'Por confirmar'}\n\nAbre la app para aceptar o ver detalles.`;
  notifWhatsApp(chofer.telefono, msg);
};

/** Notifica al cliente que su flete fue confirmado y hay chofer asignado. */
export const notifWhatsAppViajeConfirmado = (cliente, viaje, chofer) => {
  const msg = `✅ *Choyero - Tu flete está confirmado*\n\nHola ${cliente.nombre}, tu solicitud fue aceptada.\n\n🆔 *Viaje:* ${viaje.id}\n🗺️ *Ruta:* ${viaje.origen} → ${viaje.destino}\n🚛 *Chofer:* ${chofer?.nombre || 'Por asignar'}\n\nPuedes seguir tu flete en tiempo real desde la app.`;
  notifWhatsApp(cliente.telefono, msg);
};

/** Notifica al cliente que el flete fue entregado. */
export const notifWhatsAppEntregaCompletada = (cliente, viaje) => {
  const msg = `📦 *Choyero - Entrega completada*\n\nHola ${cliente.nombre}, tu flete fue entregado exitosamente.\n\n🆔 *Viaje:* ${viaje.id}\n\nPor favor califica el servicio en la app. ¡Gracias por confiar en Choyero!`;
  notifWhatsApp(cliente.telefono, msg);
};

/** Notifica al transportista que hay una nueva solicitud en su zona. */
export const notifWhatsAppNuevaSolicitud = (transportista, solicitud) => {
  const msg = `📋 *Choyero - Nueva solicitud disponible*\n\nHola ${transportista.nombre}, hay una nueva solicitud de flete:\n\n🗺️ *Ruta:* ${solicitud.origen} → ${solicitud.destino}\n📦 *Carga:* ${solicitud.tipoCarga}\n💰 *Presupuesto:* ${solicitud.presupuesto ? `$${solicitud.presupuesto.toLocaleString()}` : 'Abierto'}\n\nIngresa a la app para cotizar.`;
  notifWhatsApp(transportista.telefono, msg);
};

// ============================================================
// SISTEMA DE REFERIDOS
// ============================================================

/**
 * Genera un código de referido único para un usuario.
 * Si ya tiene código, lo retorna sin modificar el store.
 */
export const generarCodigoReferido = (userId) => {
  const store = getStore();
  const usuario = store.usuarios.find(u => u.id === userId);
  if (!usuario) return null;
  if (usuario.codigoReferido) return usuario.codigoReferido;
  const codigo = `CHY-${usuario.nombre.split(' ')[0].toUpperCase().slice(0, 4)}-${Math.random().toString(36).slice(2, 6).toUpperCase()}`;
  updateStore(s => ({
    ...s,
    usuarios: s.usuarios.map(u => u.id === userId ? { ...u, codigoReferido: codigo } : u)
  }));
  return codigo;
};

/**
 * Aplica un código de referido al unirse a la plataforma.
 * Vincula referidoPor al nuevo usuario.
 * @returns {{ ok: boolean, mensaje: string }}
 */
export const aplicarCodigoReferido = (nuevoUserId, codigoIngresado) => {
  const store = getStore();
  const referidor = store.usuarios.find(u => u.codigoReferido === codigoIngresado);
  if (!referidor) return { ok: false, mensaje: 'Código de referido no válido.' };
  if (referidor.id === nuevoUserId) return { ok: false, mensaje: 'No puedes usar tu propio código.' };
  const nuevoUsuario = store.usuarios.find(u => u.id === nuevoUserId);
  if (!nuevoUsuario) return { ok: false, mensaje: 'Usuario no encontrado.' };
  if (nuevoUsuario.referidoPor) return { ok: false, mensaje: 'Ya aplicaste un código de referido.' };

  updateStore(s => ({
    ...s,
    usuarios: s.usuarios.map(u => {
      if (u.id === referidor.id) {
        return {
          ...u,
          referidos: [...(u.referidos || []), { userId: nuevoUserId, nombre: nuevoUsuario.nombre, fecha: new Date().toISOString() }],
        };
      }
      if (u.id === nuevoUserId) {
        return { ...u, referidoPor: referidor.id };
      }
      return u;
    })
  }));
  return { ok: true, mensaje: '¡Código aplicado! Tu referidor recibirá comisiones por tu actividad.' };
};

/** Obtiene el resumen de referidos de un usuario (código + lista + bonos totales). */
export const getResumenReferidos = (userId) => {
  const store = getStore();
  const usuario = store.usuarios.find(u => u.id === userId);
  if (!usuario) return { codigo: null, referidos: [], totalBonos: 0 };
  const referidos = usuario.referidos || [];
  return {
    codigo: usuario.codigoReferido || null,
    referidos,
    totalBonos: referidos.reduce((acc, r) => acc + (r.bono || 0), 0),
  };
};

// ============================================================
// ══ RED DE MERCADEO MULTINIVEL ════════════════════════════════
// ============================================================

/**
 * Construye la cadena de referidores (hasta 3 niveles) a partir de un código.
 * REGLA: solo personas físicas pueden estar en la cadena.
 */
const _buildCadenaReferidos = (codigoReferido, store, nivelMax = 3) => {
  const chain = [];
  let current = store.usuarios.find(u => u.codigoReferido === codigoReferido);
  while (current && chain.length < nivelMax) {
    if (current.tipoPersona !== 'fisica') break; // empresa moral no puede ser referidor
    chain.push(current.id);
    if (!current.referidoPor) break;
    current = store.usuarios.find(u => u.id === current.referidoPor);
  }
  return chain;
};

/**
 * Calcula el score de riesgo de una empresa referida.
 * Retorna { score, flags }.
 */
const _calcularScoreRiesgo = (empresaData, referidorId, store) => {
  const flags = [];
  let score = 0;
  const referidor = store.usuarios.find(u => u.id === referidorId);

  // Mismo teléfono que referidor
  if (referidor && empresaData.telefono && referidor.telefono === empresaData.telefono) {
    score += 30; flags.push('Mismo teléfono que referidor');
  }
  // Mismo email domain que referidor
  const domEmpresa = (empresaData.email || '').split('@')[1];
  const domRef = (referidor?.email || '').split('@')[1];
  if (domEmpresa && domRef && domEmpresa === domRef) {
    score += 20; flags.push('Mismo dominio de email que referidor');
  }
  // RFC duplicado
  if (empresaData.rfc) {
    const rfcExiste = [...(store.empresasActivas || []), ...(store.empresasPendientes || [])]
      .some(e => e.rfc === empresaData.rfc);
    if (rfcExiste) {
      score += 40; flags.push('RFC ya registrado en el sistema');
    }
  }
  return { score, flags };
};

/**
 * Vincula una persona física recién registrada a la red, sin generar comisión.
 * Solo guarda referidoPor para construir la cadena N1→N2→N3.
 * No requiere que la red esté habilitada — el vínculo se preserva para el futuro.
 */
export const vincularPersonaFisicaRed = (userId, codigoReferido) => {
  if (!codigoReferido?.trim()) return { ok: false, mensaje: 'Código vacío.' };
  const store = getStore();
  const referidor = store.usuarios.find(u => u.codigoReferido === codigoReferido.trim().toUpperCase());
  if (!referidor) return { ok: false, mensaje: 'Código inválido.' };
  if (referidor.tipoPersona !== 'fisica') return { ok: false, mensaje: 'Solo personas físicas pueden ser referidores.' };
  if (referidor.id === userId) return { ok: false, mensaje: 'No puedes usar tu propio código.' };
  const nuevoUsuario = store.usuarios.find(u => u.id === userId);
  if (!nuevoUsuario) return { ok: false, mensaje: 'Usuario no encontrado.' };
  if (nuevoUsuario.referidoPor) return { ok: false, mensaje: 'Ya tienes un referidor registrado.' };
  updateStore(s => ({
    ...s,
    usuarios: s.usuarios.map(u =>
      u.id === userId ? { ...u, referidoPor: referidor.id, codigoUsado: codigoReferido.trim().toUpperCase() } : u
    ),
  }));
  return { ok: true, mensaje: `Vinculado a la red de ${referidor.nombre}.` };
};

/**
 * Vincula una empresa modal recién registrada con su referidor.
 * Crea registros de comisión en estado 'pendiente'.
 * Llamar DESPUÉS de registrarTransportista / registrarCliente.
 */
export const vincularReferidoEmpresa = (empresaId, tipoEmpresa, codigoReferido) => {
  const store = getStore();
  const cfg = store.configPlataforma?.redMercadeo;
  if (!cfg?.habilitada) return { ok: false, mensaje: 'Red de mercadeo no está activa.' };
  if (!codigoReferido?.trim()) return { ok: false, mensaje: 'Código vacío.' };

  const cadena = _buildCadenaReferidos(codigoReferido.trim().toUpperCase(), store);
  if (cadena.length === 0) return { ok: false, mensaje: 'Código inválido o el referidor no es persona física.' };

  const bonos = tipoEmpresa === 'transportista'
    ? [cfg.bonoTransN1, cfg.bonoTransN2, cfg.bonoTransN3]
    : [cfg.bonoClienteN1, cfg.bonoClienteN2, cfg.bonoClienteN3];

  const fechaExpiracion = new Date(Date.now() + (cfg.diasExpiracion || 60) * 86400000).toISOString();
  const referidorId = cadena[0];
  const empresaData = [...(store.empresasActivas || []), ...(store.empresasPendientes || [])]
    .find(e => e.id === empresaId) || {};
  const { score, flags } = _calcularScoreRiesgo(empresaData, referidorId, store);

  const nuevasComisiones = cadena.map((userId, idx) => ({
    id: `COM-${Date.now()}-N${idx + 1}`,
    fecha: new Date().toISOString(),
    tipo: `registro_${tipoEmpresa}`,
    status: score >= 60 ? 'congelada' : 'pendiente',
    nivel: idx + 1,
    userId: userId,
    empresaId: empresaId,
    origenFleteId: null,
    monto: bonos[idx] || 0,
    scoreRiesgo: score,
    flagsRiesgo: flags,
    fechaLiberacion: null,
    fechaExpiracion,
  })).filter(c => c.monto > 0);

  updateStore(s => ({
    ...s,
    comisionesRed: [...(s.comisionesRed || []), ...nuevasComisiones],
    // Marcar la empresa con su cadena de referidos (transportistas en empresasPendientes)
    empresasPendientes: (s.empresasPendientes || []).map(e =>
      e.id === empresaId ? { ...e, cadenaReferidos: cadena, referidaPor: referidorId, codigoUsado: codigoReferido } : e
    ),
    empresasActivas: (s.empresasActivas || []).map(e =>
      e.id === empresaId ? { ...e, cadenaReferidos: cadena, referidaPor: referidorId, codigoUsado: codigoReferido } : e
    ),
    // Para clientes persona moral (usuarios sin empresaId propio)
    usuarios: (s.usuarios || []).map(u =>
      (u.empresaId === empresaId || u.id === empresaId)
        ? { ...u, cadenaReferidos: cadena, referidaPor: referidorId, codigoUsado: codigoReferido }
        : u
    ),
  }));

  return { ok: true, comisionesCreadas: nuevasComisiones.length, scoreRiesgo: score, flagsRiesgo: flags };
};

/**
 * Libera las comisiones pendientes de una empresa al completar su primer flete.
 * Mueve 'pendiente' → 'disponible' para los beneficiarios.
 */
export const liberarComisionesPrimerFlete = (empresaId) => {
  updateStore(store => {
    const pendientes = (store.comisionesRed || []).filter(
      c => c.empresaId === empresaId && c.status === 'pendiente'
    );
    if (pendientes.length === 0) return store;

    const ahora = new Date().toISOString();
    const comisionesRed = (store.comisionesRed || []).map(c => {
      if (c.empresaId === empresaId && c.status === 'pendiente') {
        return { ...c, status: 'disponible', fechaLiberacion: ahora };
      }
      return c;
    });

    // Marcar empresa como primerFleteCompletado
    const empresasActivas = (store.empresasActivas || []).map(e =>
      e.id === empresaId ? { ...e, primerFleteCompletado: true } : e
    );
    return { ...store, comisionesRed, empresasActivas };
  });
};

/**
 * Procesa comisiones recurrentes de la red al completar un flete.
 * Acredita % de la comisión Choyero a cada nivel de la cadena del transportista.
 */
export const procesarComisionFleteRed = (empresaId, montoComisionChoyero) => {
  const store = getStore();
  const cfg = store.configPlataforma?.redMercadeo;
  if (!cfg?.habilitada) return;

  const empresa = (store.empresasActivas || []).find(e => e.id === empresaId);
  const cadena = empresa?.cadenaReferidos || [];
  if (cadena.length === 0) return;

  const pcts = [cfg.pctFleteN1 / 100, cfg.pctFleteN2 / 100, cfg.pctFleteN3 / 100];
  const ahora = new Date().toISOString();

  const nuevasComisiones = cadena.map((userId, idx) => ({
    id: `COM-F-${Date.now()}-N${idx + 1}`,
    fecha: ahora,
    tipo: 'flete',
    status: 'disponible', // comisiones por flete se pagan directamente
    nivel: idx + 1,
    userId: userId,
    empresaId: empresaId,
    origenFleteId: null,
    monto: Math.round(montoComisionChoyero * (pcts[idx] || 0)),
    scoreRiesgo: 0,
    flagsRiesgo: [],
    fechaLiberacion: ahora,
    fechaExpiracion: null,
  })).filter(c => c.monto > 0);

  if (nuevasComisiones.length === 0) return;

  updateStore(s => ({
    ...s,
    comisionesRed: [...(s.comisionesRed || []), ...nuevasComisiones],
  }));
};

/** Obtiene el saldo de red de un usuario (disponible, pendiente, total). */
export const getSaldoRedUsuario = (userId) => {
  const { comisionesRed, usuarios } = getStore();
  const usuario = usuarios.find(u => u.id === userId);
  const misComisiones = (comisionesRed || []).filter(c => c.userId === userId);
  return {
    disponible: misComisiones.filter(c => c.status === 'disponible').reduce((s, c) => s + c.monto, 0),
    pendiente: misComisiones.filter(c => c.status === 'pendiente').reduce((s, c) => s + c.monto, 0),
    congelado: misComisiones.filter(c => c.status === 'congelada').reduce((s, c) => s + c.monto, 0),
    historico: misComisiones,
    totalGanado: misComisiones.filter(c => c.status === 'disponible' || c.status === 'pagada').reduce((s, c) => s + c.monto, 0),
  };
};

/**
 * Construye el árbol de referidos de un usuario (para vista admin o usuario).
 * Retorna nodos con empresa, nivel, comisiones y sub-referidos.
 */
export const getArbolReferidos = (userId) => {
  const store = getStore();
  const _buildNode = (uid, nivelActual, maxNivel = 3) => {
    if (nivelActual > maxNivel) return [];
    const usuario = store.usuarios.find(u => u.id === uid);
    if (!usuario) return [];

    // Empresas que este usuario refirió directamente (transportistas + clientes morales)
    const empresasReferidas = [
      ...(store.empresasActivas || []).filter(e => e.referidaPor === uid),
      ...(store.empresasPendientes || []).filter(e => e.referidaPor === uid),
      // Clientes morales viven en usuarios, no en empresasActivas
      ...(store.usuarios || [])
        .filter(u => u.referidoPor === uid && u.tipoPersona === 'moral')
        .map(u => ({
          id: u.id,
          nombre: u.nombre || u.razonSocial || u.email,
          rfc: u.rfc || null,
          status: 'activo',
          primerFleteCompletado: u.primerFleteCompletado || false,
          esClienteMoral: true,
        })),
    ];
    // Usuarios personas físicas referidos por este usuario
    const usuariosReferidos = (store.usuarios || []).filter(u => u.referidoPor === uid && u.tipoPersona === 'fisica');

    const misComisiones = (store.comisionesRed || []).filter(c => c.userId === uid);

    return [{
      userId: uid,
      nombre: usuario.nombre,
      email: usuario.email,
      tipoPersona: usuario.tipoPersona || 'fisica',
      nivel: nivelActual,
      codigoReferido: usuario.codigoReferido || null,
      empresasReferidas: empresasReferidas.map(e => ({
        id: e.id, nombre: e.nombre, rfc: e.rfc,
        status: e.status || 'pendiente',
        primerFlete: !!e.primerFleteCompletado,
        comisiones: misComisiones.filter(c => c.empresaId === e.id),
      })),
      totalEmpresasReferidas: empresasReferidas.length,
      comisionesDisponibles: misComisiones.filter(c => c.status === 'disponible').reduce((s,c) => s+c.monto, 0),
      comisionesPendientes: misComisiones.filter(c => c.status === 'pendiente').reduce((s,c) => s+c.monto, 0),
      subRed: usuariosReferidos.flatMap(u => _buildNode(u.id, nivelActual + 1, maxNivel)),
    }];
  };
  return _buildNode(userId, 1);
};

/** SuperAdmin: actualizar configuración de la red de mercadeo. */
export const actualizarConfigRedMercadeo = (cambios) =>
  updateStore(store => ({
    ...store,
    configPlataforma: {
      ...store.configPlataforma,
      redMercadeo: { ...store.configPlataforma.redMercadeo, ...cambios },
    },
  }));

/** SuperAdmin: gestionar una comisión (aprobar/rechazar/pagar). */
export const gestionarComisionRed = (comisionId, accion) =>
  updateStore(store => ({
    ...store,
    comisionesRed: (store.comisionesRed || []).map(c => {
      if (c.id !== comisionId) return c;
      const mapStatus = { aprobar: 'disponible', rechazar: 'revertida', pagar: 'pagada', congelar: 'congelada' };
      return { ...c, status: mapStatus[accion] || c.status, fechaGestion: new Date().toISOString() };
    }),
  }));

/**
 * Referidor solicita retiro de sus fondos disponibles.
 * Crea un registro de retiro pendiente.
 * El admin aprueba y marca como pagado (o rechaza).
 * @param {string} userId
 * @param {number} monto
 * @param {'spei'|'efectivo'|'cheque'} metodoPago
 * @param {{ clabe?: string, banco?: string, titular?: string, referencia?: string }} datos
 */
export const solicitarRetiroFondos = (userId, monto, metodoPago, datos = {}) => {
  const store = getStore();
  const usuario = store.usuarios.find(u => u.id === userId);
  if (!usuario) return { ok: false, mensaje: 'Usuario no encontrado.' };
  if (!monto || monto <= 0) return { ok: false, mensaje: 'Monto inválido.' };
  const misComisiones = (store.comisionesRed || []).filter(c => c.userId === userId);
  const disponible = misComisiones.filter(c => c.status === 'disponible').reduce((s, c) => s + c.monto, 0);
  if (monto > disponible) return { ok: false, mensaje: `Saldo insuficiente. Tienes $${disponible.toLocaleString()} disponibles.` };
  if (monto < 200) return { ok: false, mensaje: 'El monto mínimo de retiro es $200.' };
  // Validar datos SPEI
  if (metodoPago === 'spei' && !datos.clabe?.trim()) return { ok: false, mensaje: 'Ingresa la CLABE interbancaria.' };

  const retiro = {
    id: `RET-${Date.now()}`,
    fecha: new Date().toISOString(),
    userId,
    monto,
    metodoPago,
    datos,
    status: 'pendiente',
    fechaGestion: null,
    notasAdmin: '',
  };

  updateStore(s => {
    const notificaciones = _agregarNotif(s, {
      destinatarioRol: 'superadmin',
      tipo: 'retiro_solicitado',
      titulo: '💸 Nueva solicitud de retiro',
      mensaje: `${s.usuarios.find(u => u.id === userId)?.nombre || userId} solicitó retirar $${monto.toLocaleString()} MXN via ${metodoPago.toUpperCase()}.`,
      datos: { retiroId: retiro.id, userId, monto },
    });
    return { ...s, retirosFondos: [...(s.retirosFondos || []), retiro], notificaciones };
  });
  return { ok: true, mensaje: 'Solicitud enviada. El pago se procesará en 1-3 días hábiles.', retiroId: retiro.id };
};

/**
 * SuperAdmin gestiona un retiro: 'aprobar' | 'pagar' | 'rechazar'.
 * Si se rechaza, el retiro queda en estado 'rechazado'.
 */
export const gestionarRetiroFondos = (retiroId, accion, notasAdmin = '') =>
  updateStore(store => {
    const retiro = (store.retirosFondos || []).find(r => r.id === retiroId);
    if (!retiro) return store;
    const mapStatus = { aprobar: 'aprobado', pagar: 'pagado', rechazar: 'rechazado' };
    const nuevoStatus = mapStatus[accion] || retiro.status;
    const ahora = new Date().toISOString();

    // Guard: no operar sobre retiros ya finalizados (evita doble reembolso)
    if (retiro.status === 'pagado' || retiro.status === 'rechazado') return store;

    return {
      ...store,
      retirosFondos: (store.retirosFondos || []).map(r =>
        r.id === retiroId ? { ...r, status: nuevoStatus, fechaGestion: ahora, notasAdmin } : r
      ),
    };
  });

/** Cancela comisiones pendientes expiradas (sin primer flete en N días). */
export const limpiarComisionesExpiradas = () =>
  updateStore(store => ({
    ...store,
    comisionesRed: (store.comisionesRed || []).map(c => {
      if (c.status !== 'pendiente' || !c.fechaExpiracion) return c;
      if (new Date() > new Date(c.fechaExpiracion)) {
        return { ...c, status: 'revertida', fechaGestion: new Date().toISOString() };
      }
      return c;
    }),
  }));
